var _desc, _defs, _circle, _circle2, _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g0, _g1, _g10, _line, _line2, _line3, _line4, _line5, _line6, _line7, _line8, _line9, _line0, _line1, _line10, _line11, _line12, _line13, _line14, _line15, _line16, _line17, _line18, _line19, _line20, _line21, _line22, _line23, _line24, _line25, _line26, _line27, _line28, _line29, _line30, _line31, _line32, _line33, _line34, _line35, _line36, _line37, _line38, _line39, _line40, _line41, _line42, _line43, _line44, _line45, _line46, _line47, _line48, _line49, _line50, _line51, _line52, _line53, _line54, _line55, _line56, _line57, _line58, _line59, _line60, _line61, _line62, _line63, _line64, _line65, _line66, _line67, _line68, _line69, _line70, _line71, _line72, _line73, _line74, _line75, _line76, _line77, _line78, _line79, _line80, _line81, _line82, _line83, _line84, _line85, _line86, _line87, _line88, _line89, _line90, _line91, _line92, _line93, _line94, _line95, _line96, _line97, _line98, _line99, _line100, _line101, _line102, _line103, _line104, _line105, _line106, _line107, _line108, _line109, _line110, _line111, _line112, _line113, _line114, _line115, _line116, _line117, _line118, _line119, _line120, _line121, _line122, _line123, _line124, _line125, _line126, _line127, _line128, _line129, _line130, _line131, _line132, _line133, _line134, _line135, _line136, _line137, _line138, _line139, _line140, _line141, _line142, _line143, _line144, _line145, _line146, _line147, _line148, _line149, _line150, _line151, _line152, _line153, _line154, _line155, _line156, _line157, _line158, _line159, _line160, _line161, _line162, _line163, _line164, _line165, _line166, _line167, _line168, _line169, _line170, _line171, _line172, _line173, _line174, _line175, _line176, _line177, _line178, _line179, _line180, _line181, _line182, _line183, _line184, _line185, _line186, _line187, _line188, _line189, _line190, _line191, _line192, _line193, _line194, _line195, _line196, _line197, _line198, _line199, _line200, _line201, _line202, _line203, _line204, _line205, _line206, _line207, _line208, _line209, _line210, _line211, _line212, _line213, _line214, _line215, _line216, _line217, _line218, _line219, _line220, _line221, _line222, _line223, _line224, _line225, _line226, _line227, _line228, _line229, _line230, _line231, _line232, _line233, _line234, _line235, _line236, _line237, _line238, _line239, _line240, _line241, _line242, _line243, _line244, _line245, _line246, _line247, _line248, _line249, _line250, _line251, _line252, _line253, _line254, _line255, _line256, _line257, _line258, _line259, _line260, _line261, _line262, _line263, _line264, _line265, _line266, _line267, _line268, _line269, _line270, _line271, _line272, _line273, _line274, _line275, _line276, _line277, _line278, _line279, _line280, _line281, _line282, _line283, _line284, _line285, _line286, _line287, _line288, _line289, _line290, _line291, _line292, _line293, _line294, _line295, _line296, _line297, _line298, _line299, _line300, _line301, _line302, _line303, _line304, _line305, _line306, _line307, _line308, _line309, _line310, _line311, _line312, _line313, _line314, _line315, _line316, _line317, _line318, _line319, _line320, _line321, _line322, _line323, _line324, _line325, _line326, _line327, _line328, _line329, _line330, _line331, _line332, _line333, _line334, _line335, _line336, _line337, _line338, _line339, _line340, _line341, _line342, _line343, _line344, _line345, _line346, _line347, _line348, _line349, _line350, _line351, _line352, _line353, _line354, _line355, _line356, _line357, _line358, _g11, _g12, _g13, _g14, _g15, _g16, _g17, _g18, _g19, _g20, _g21, _g22, _circle3, _g23, _g24, _g25, _g26, _g27, _g28, _g29, _g30, _g31, _g32, _g33, _g34, _g35, _g36, _g37, _g38, _g39, _g40, _g41, _g42, _g43, _g44, _g45, _g46, _g47, _g48, _g49;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgLandingChartPreview = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  className: "natal-wheel-svg",
  viewBox: "0 0 600 600",
  role: "img",
  "aria-labelledby": titleId,
  ref: ref
}, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
  id: titleId || "R0-title"
}, "\u0418\u043B\u043B\u044E\u0441\u0442\u0440\u0430\u0442\u0438\u0432\u043D\u0430\u044F \u043D\u0430\u0442\u0430\u043B\u044C\u043D\u0430\u044F \u043A\u0430\u0440\u0442\u0430") : title ? /*#__PURE__*/React.createElement("title", {
  id: titleId || "R0-title"
}, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", {
  id: "R0-description"
}, "ASC \u0441\u043B\u0435\u0432\u0430. \u0423\u0433\u043B\u044B \u0438 \u043A\u0443\u0441\u043F\u0438\u0434\u044B \u0441\u043B\u0435\u0434\u0443\u044E\u0442 \u0434\u043E\u043B\u0433\u043E\u0442\u0430\u043C API. \u0422\u043E\u0447\u043A\u0438 \u043D\u0430 \u043E\u043A\u0440\u0443\u0436\u043D\u043E\u0441\u0442\u0438 \u2014 \u0442\u043E\u0447\u043D\u044B\u0435 \u043F\u043E\u043B\u043E\u0436\u0435\u043D\u0438\u044F; \u043B\u0438\u043D\u0438\u0438 \u0432\u0435\u0434\u0443\u0442 \u043A \u043F\u043E\u0434\u043F\u0438\u0441\u044F\u043C. \u0422\u0430\u0431\u043B\u0438\u0446\u044B \u0438 \u0434\u043E\u0441\u0442\u0443\u043F\u043D\u044B\u0435 \u043A\u043D\u043E\u043F\u043A\u0438 \u043D\u0430\u0445\u043E\u0434\u044F\u0442\u0441\u044F \u043F\u043E\u0434 \u043A\u0430\u0440\u0442\u043E\u0439.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("symbol", {
  id: "R0-g0",
  viewBox: "0 0 24 24"
}, /*#__PURE__*/React.createElement("path", {
  d: "M19 12a7 7 0 1 1-14 0 7 7 0 0 1 14 0 M12 11.5v1",
  fill: "none",
  stroke: "currentColor",
  strokeWidth: 1.65,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), /*#__PURE__*/React.createElement("symbol", {
  id: "R0-g1",
  viewBox: "0 0 24 24"
}, /*#__PURE__*/React.createElement("path", {
  d: "M15 3a9 9 0 1 0 0 18 10 10 0 0 1 0-18Z",
  fill: "none",
  stroke: "currentColor",
  strokeWidth: 1.65,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), /*#__PURE__*/React.createElement("symbol", {
  id: "R0-g2",
  viewBox: "0 0 24 24"
}, /*#__PURE__*/React.createElement("path", {
  d: "M7 3a5 5 0 0 0 10 0 M17 10a5 5 0 1 1-10 0 5 5 0 0 1 10 0 M12 15v7 M8 19h8",
  fill: "none",
  stroke: "currentColor",
  strokeWidth: 1.65,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), /*#__PURE__*/React.createElement("symbol", {
  id: "R0-g3",
  viewBox: "0 0 24 24"
}, /*#__PURE__*/React.createElement("path", {
  d: "M18 8a6 6 0 1 1-12 0 6 6 0 0 1 12 0 M12 14v8 M8 19h8",
  fill: "none",
  stroke: "currentColor",
  strokeWidth: 1.65,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), /*#__PURE__*/React.createElement("symbol", {
  id: "R0-g4",
  viewBox: "0 0 24 24"
}, /*#__PURE__*/React.createElement("path", {
  d: "M15 15a6 6 0 1 1-12 0 6 6 0 0 1 12 0 M13 11l8-8 M15 3h6v6",
  fill: "none",
  stroke: "currentColor",
  strokeWidth: 1.65,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), /*#__PURE__*/React.createElement("symbol", {
  id: "R0-g5",
  viewBox: "0 0 24 24"
}, /*#__PURE__*/React.createElement("path", {
  d: "M5 5c8-5 9 6 0 9h14 M15 3v19",
  fill: "none",
  stroke: "currentColor",
  strokeWidth: 1.65,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), /*#__PURE__*/React.createElement("symbol", {
  id: "R0-g6",
  viewBox: "0 0 24 24"
}, /*#__PURE__*/React.createElement("path", {
  d: "M8 2v15 M4 6h9 M8 11c10-6 11 4 7 9q-1 3 3 1",
  fill: "none",
  stroke: "currentColor",
  strokeWidth: 1.65,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), /*#__PURE__*/React.createElement("symbol", {
  id: "R0-g7",
  viewBox: "0 0 24 24"
}, /*#__PURE__*/React.createElement("path", {
  d: "M4 3v11 M20 3v11 M4 9h16 M12 3v13 M15 19a3 3 0 1 1-6 0 3 3 0 0 1 6 0",
  fill: "none",
  stroke: "currentColor",
  strokeWidth: 1.65,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), /*#__PURE__*/React.createElement("symbol", {
  id: "R0-g8",
  viewBox: "0 0 24 24"
}, /*#__PURE__*/React.createElement("path", {
  d: "M5 3v5a7 7 0 0 0 14 0V3 M12 2v20 M8 18h8",
  fill: "none",
  stroke: "currentColor",
  strokeWidth: 1.65,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), /*#__PURE__*/React.createElement("symbol", {
  id: "R0-g9",
  viewBox: "0 0 24 24"
}, /*#__PURE__*/React.createElement("path", {
  d: "M15 6a3 3 0 1 1-6 0 3 3 0 0 1 6 0 M5 7a7 7 0 0 0 14 0 M12 14v8 M8 19h8",
  fill: "none",
  stroke: "currentColor",
  strokeWidth: 1.65,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), /*#__PURE__*/React.createElement("symbol", {
  id: "R0-g10",
  viewBox: "0 0 24 24"
}, /*#__PURE__*/React.createElement("path", {
  d: "M7 18C-2 4 26 4 17 18 M8 19a3 3 0 1 1-6 0 3 3 0 0 1 6 0 M22 19a3 3 0 1 1-6 0 3 3 0 0 1 6 0",
  fill: "none",
  stroke: "currentColor",
  strokeWidth: 1.65,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), /*#__PURE__*/React.createElement("symbol", {
  id: "R0-g11",
  viewBox: "0 0 24 24"
}, /*#__PURE__*/React.createElement("path", {
  d: "M7 6C-2 20 26 20 17 6 M8 5a3 3 0 1 1-6 0 3 3 0 0 1 6 0 M22 5a3 3 0 1 1-6 0 3 3 0 0 1 6 0",
  fill: "none",
  stroke: "currentColor",
  strokeWidth: 1.65,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), /*#__PURE__*/React.createElement("symbol", {
  id: "R0-g12",
  viewBox: "0 0 24 24"
}, /*#__PURE__*/React.createElement("path", {
  d: "M15 18a4 4 0 1 1-8 0 4 4 0 0 1 8 0 M11 14V2 M11 8l8-6 M11 8l8 6",
  fill: "none",
  stroke: "currentColor",
  strokeWidth: 1.65,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), /*#__PURE__*/React.createElement("symbol", {
  id: "R0-g13",
  viewBox: "0 0 24 24"
}, /*#__PURE__*/React.createElement("path", {
  d: "M5 10C1 0 19 0 19 10H12v12 M8 18h8",
  fill: "none",
  stroke: "currentColor",
  strokeWidth: 1.65,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), /*#__PURE__*/React.createElement("symbol", {
  id: "R0-g14",
  viewBox: "0 0 24 24"
}, /*#__PURE__*/React.createElement("path", {
  d: "M12 2l6 6-6 6-6-6Z M12 14v8 M8 18h8",
  fill: "none",
  stroke: "currentColor",
  strokeWidth: 1.65,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), /*#__PURE__*/React.createElement("symbol", {
  id: "R0-g15",
  viewBox: "0 0 24 24"
}, /*#__PURE__*/React.createElement("path", {
  d: "M12 2v12 M6 5l12 6 M18 5L6 11 M12 14v8 M8 18h8",
  fill: "none",
  stroke: "currentColor",
  strokeWidth: 1.65,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), /*#__PURE__*/React.createElement("symbol", {
  id: "R0-g16",
  viewBox: "0 0 24 24"
}, /*#__PURE__*/React.createElement("path", {
  d: "M12 2c-7 9-7 11 0 14 7-3 7-5 0-14Z M4 17l8 5 8-5",
  fill: "none",
  stroke: "currentColor",
  strokeWidth: 1.65,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), /*#__PURE__*/React.createElement("symbol", {
  id: "R0-g17",
  viewBox: "0 0 24 24"
}, /*#__PURE__*/React.createElement("path", {
  d: "M14 2a7 7 0 1 0 0 14 8 8 0 0 1 0-14Z M11 16v6 M7 19h8",
  fill: "none",
  stroke: "currentColor",
  strokeWidth: 1.65,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), /*#__PURE__*/React.createElement("symbol", {
  id: "R0-g18",
  viewBox: "0 0 24 24"
}, /*#__PURE__*/React.createElement("path", {
  d: "M12 2v20 M18 12a6 6 0 1 1-12 0 6 6 0 0 1 12 0",
  fill: "none",
  stroke: "currentColor",
  strokeWidth: 1.65,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), /*#__PURE__*/React.createElement("symbol", {
  id: "R0-g19",
  viewBox: "0 0 24 24"
}, /*#__PURE__*/React.createElement("path", {
  d: "M3 5l4 15 5-12 5 12 4-15",
  fill: "none",
  stroke: "currentColor",
  strokeWidth: 1.65,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), /*#__PURE__*/React.createElement("symbol", {
  id: "R0-g20",
  viewBox: "0 0 24 24"
}, /*#__PURE__*/React.createElement("path", {
  d: "M20 12a8 8 0 1 1-16 0 8 8 0 0 1 16 0 M6 6l12 12 M18 6L6 18",
  fill: "none",
  stroke: "currentColor",
  strokeWidth: 1.65,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), /*#__PURE__*/React.createElement("symbol", {
  id: "R0-g21",
  viewBox: "0 0 24 24"
}, /*#__PURE__*/React.createElement("path", {
  d: "M2 5l5 14 5-14 M14 10l8 9 M22 10l-8 9",
  fill: "none",
  stroke: "currentColor",
  strokeWidth: 1.65,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), /*#__PURE__*/React.createElement("symbol", {
  id: "R0-g22",
  viewBox: "0 0 24 24"
}, /*#__PURE__*/React.createElement("path", {
  d: "M12 21V8C12-2 0 1 4 10 M12 8C12-2 24 1 20 10",
  fill: "none",
  stroke: "currentColor",
  strokeWidth: 1.65,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), /*#__PURE__*/React.createElement("symbol", {
  id: "R0-g23",
  viewBox: "0 0 24 24"
}, /*#__PURE__*/React.createElement("path", {
  d: "M18 15a6 6 0 1 1-12 0 6 6 0 0 1 12 0 M5 2c0 9 14 9 14 0",
  fill: "none",
  stroke: "currentColor",
  strokeWidth: 1.65,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), /*#__PURE__*/React.createElement("symbol", {
  id: "R0-g24",
  viewBox: "0 0 24 24"
}, /*#__PURE__*/React.createElement("path", {
  d: "M4 3q8 4 16 0 M4 21q8-4 16 0 M8 5v14 M16 5v14",
  fill: "none",
  stroke: "currentColor",
  strokeWidth: 1.65,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), /*#__PURE__*/React.createElement("symbol", {
  id: "R0-g25",
  viewBox: "0 0 24 24"
}, /*#__PURE__*/React.createElement("path", {
  d: "M20 5C11 0 1 7 5 10c4 3 8-4 2-4 M4 19c9 5 19-2 15-5-4-3-8 4-2 4",
  fill: "none",
  stroke: "currentColor",
  strokeWidth: 1.65,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), /*#__PURE__*/React.createElement("symbol", {
  id: "R0-g26",
  viewBox: "0 0 24 24"
}, /*#__PURE__*/React.createElement("path", {
  d: "M9 16a4 4 0 1 1-8 0 4 4 0 0 1 8 0 M8 14C-1-1 20-2 16 10s-7 15 6 9",
  fill: "none",
  stroke: "currentColor",
  strokeWidth: 1.65,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), /*#__PURE__*/React.createElement("symbol", {
  id: "R0-g27",
  viewBox: "0 0 24 24"
}, /*#__PURE__*/React.createElement("path", {
  d: "M3 21V6q2-7 5 0v15 M8 6q3-7 5 0v15 M13 6q3-7 5 0v10 M15 12q9-8 7 0c-2 6-5 8-9 9",
  fill: "none",
  stroke: "currentColor",
  strokeWidth: 1.65,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), /*#__PURE__*/React.createElement("symbol", {
  id: "R0-g28",
  viewBox: "0 0 24 24"
}, /*#__PURE__*/React.createElement("path", {
  d: "M3 15h5a6 6 0 1 1 8 0h5 M3 21h18",
  fill: "none",
  stroke: "currentColor",
  strokeWidth: 1.65,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), /*#__PURE__*/React.createElement("symbol", {
  id: "R0-g29",
  viewBox: "0 0 24 24"
}, /*#__PURE__*/React.createElement("path", {
  d: "M3 21V6q2-7 5 0v15 M8 6q3-7 5 0v15 M13 6q3-7 5 0v10q0 5 5 3 M20 15l3 4-4 3",
  fill: "none",
  stroke: "currentColor",
  strokeWidth: 1.65,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), /*#__PURE__*/React.createElement("symbol", {
  id: "R0-g30",
  viewBox: "0 0 24 24"
}, /*#__PURE__*/React.createElement("path", {
  d: "M3 21L21 3 M11 3h10v10 M5 10l9 9",
  fill: "none",
  stroke: "currentColor",
  strokeWidth: 1.65,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), /*#__PURE__*/React.createElement("symbol", {
  id: "R0-g31",
  viewBox: "0 0 24 24"
}, /*#__PURE__*/React.createElement("path", {
  d: "M2 5l5 16 5-16q4-4 4 4v8a4 4 0 1 0 4-4q-5 0-8 8",
  fill: "none",
  stroke: "currentColor",
  strokeWidth: 1.65,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), /*#__PURE__*/React.createElement("symbol", {
  id: "R0-g32",
  viewBox: "0 0 24 24"
}, /*#__PURE__*/React.createElement("path", {
  d: "M2 9l4-4 4 4 4-4 4 4 4-4 M2 19l4-4 4 4 4-4 4 4 4-4",
  fill: "none",
  stroke: "currentColor",
  strokeWidth: 1.65,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), /*#__PURE__*/React.createElement("symbol", {
  id: "R0-g33",
  viewBox: "0 0 24 24"
}, /*#__PURE__*/React.createElement("path", {
  d: "M5 2q9 10 0 20 M19 2q-9 10 0 20 M2 12h20",
  fill: "none",
  stroke: "currentColor",
  strokeWidth: 1.65,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  cx: 300,
  cy: 300,
  r: 270,
  className: "wheel-surface"
})), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
  cx: 300,
  cy: 300,
  r: 240,
  className: "wheel-ring"
})), _g || (_g = /*#__PURE__*/React.createElement("g", {
  className: "zodiac-sign",
  "data-sign": 0
}, /*#__PURE__*/React.createElement("title", null, "\u041E\u0432\u0435\u043D"), /*#__PURE__*/React.createElement("line", {
  x1: 259.7395390064365,
  y1: 63.40098208025938,
  x2: 254.70698138224103,
  y2: 33.826104840291805
}), /*#__PURE__*/React.createElement("use", {
  href: "#R0-g22",
  x: 182.61723962394643,
  y: 57.25076419808593,
  width: 22,
  height: 22,
  "aria-hidden": "true"
}))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
  className: "zodiac-sign",
  "data-sign": 1
}, /*#__PURE__*/React.createElement("title", null, "\u0422\u0435\u043B\u0435\u0446"), /*#__PURE__*/React.createElement("line", {
  x1: 146.8339090516312,
  y1: 115.22947046783673,
  x2: 127.6881476830851,
  y2: 92.13315427631633
}), /*#__PURE__*/React.createElement("use", {
  href: "#R0-g23",
  x: 80.99520908866793,
  y: 141.4906546759391,
  width: 22,
  height: 22,
  "aria-hidden": "true"
}))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
  className: "zodiac-sign",
  "data-sign": 2
}, /*#__PURE__*/React.createElement("title", null, "\u0411\u043B\u0438\u0437\u043D\u0435\u0446\u044B"), /*#__PURE__*/React.createElement("line", {
  x1: 74.96900947427321,
  y1: 216.56707302862822,
  x2: 46.84013565855736,
  y2: 206.13795715720676
}), /*#__PURE__*/React.createElement("use", {
  href: "#R0-g24",
  x: 35.107894299885515,
  y: 265.25555510941797,
  width: 22,
  height: 22,
  "aria-hidden": "true"
}))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
  className: "zodiac-sign",
  "data-sign": 3
}, /*#__PURE__*/React.createElement("title", null, "\u0420\u0430\u043A"), /*#__PURE__*/React.createElement("line", {
  x1: 63.400982080259354,
  y1: 340.26046099356347,
  x2: 33.82610484029175,
  y2: 345.2930186177589
}), /*#__PURE__*/React.createElement("use", {
  href: "#R0-g25",
  x: 57.25076419808599,
  y: 395.38276037605374,
  width: 22,
  height: 22,
  "aria-hidden": "true"
}))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
  className: "zodiac-sign",
  "data-sign": 4
}, /*#__PURE__*/React.createElement("title", null, "\u041B\u0435\u0432"), /*#__PURE__*/React.createElement("line", {
  x1: 115.22947046783676,
  y1: 453.16609094836883,
  x2: 92.13315427631636,
  y2: 472.31185231691495
}), /*#__PURE__*/React.createElement("use", {
  href: "#R0-g26",
  x: 141.49065467593906,
  y: 497.004790911332,
  width: 22,
  height: 22,
  "aria-hidden": "true"
}))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
  className: "zodiac-sign",
  "data-sign": 5
}, /*#__PURE__*/React.createElement("title", null, "\u0414\u0435\u0432\u0430"), /*#__PURE__*/React.createElement("line", {
  x1: 216.56707302862822,
  y1: 525.0309905257268,
  x2: 206.13795715720673,
  y2: 553.1598643414427
}), /*#__PURE__*/React.createElement("use", {
  href: "#R0-g27",
  x: 265.255555109418,
  y: 542.8921057001145,
  width: 22,
  height: 22,
  "aria-hidden": "true"
}))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
  className: "zodiac-sign",
  "data-sign": 6
}, /*#__PURE__*/React.createElement("title", null, "\u0412\u0435\u0441\u044B"), /*#__PURE__*/React.createElement("line", {
  x1: 340.2604609935636,
  y1: 536.5990179197406,
  x2: 345.293018617759,
  y2: 566.1738951597082
}), /*#__PURE__*/React.createElement("use", {
  href: "#R0-g28",
  x: 395.3827603760536,
  y: 520.749235801914,
  width: 22,
  height: 22,
  "aria-hidden": "true"
}))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
  className: "zodiac-sign",
  "data-sign": 7
}, /*#__PURE__*/React.createElement("title", null, "\u0421\u043A\u043E\u0440\u043F\u0438\u043E\u043D"), /*#__PURE__*/React.createElement("line", {
  x1: 453.16609094836883,
  y1: 484.77052953216327,
  x2: 472.31185231691495,
  y2: 507.8668457236837
}), /*#__PURE__*/React.createElement("use", {
  href: "#R0-g29",
  x: 497.00479091133207,
  y: 436.50934532406086,
  width: 22,
  height: 22,
  "aria-hidden": "true"
}))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
  className: "zodiac-sign",
  "data-sign": 8
}, /*#__PURE__*/React.createElement("title", null, "\u0421\u0442\u0440\u0435\u043B\u0435\u0446"), /*#__PURE__*/React.createElement("line", {
  x1: 525.0309905257268,
  y1: 383.4329269713718,
  x2: 553.1598643414427,
  y2: 393.8620428427933
}), /*#__PURE__*/React.createElement("use", {
  href: "#R0-g30",
  x: 542.8921057001145,
  y: 312.744444890582,
  width: 22,
  height: 22,
  "aria-hidden": "true"
}))), _g0 || (_g0 = /*#__PURE__*/React.createElement("g", {
  className: "zodiac-sign",
  "data-sign": 9
}, /*#__PURE__*/React.createElement("title", null, "\u041A\u043E\u0437\u0435\u0440\u043E\u0433"), /*#__PURE__*/React.createElement("line", {
  x1: 536.5990179197406,
  y1: 259.7395390064365,
  x2: 566.1738951597083,
  y2: 254.70698138224103
}), /*#__PURE__*/React.createElement("use", {
  href: "#R0-g31",
  x: 520.749235801914,
  y: 182.61723962394638,
  width: 22,
  height: 22,
  "aria-hidden": "true"
}))), _g1 || (_g1 = /*#__PURE__*/React.createElement("g", {
  className: "zodiac-sign",
  "data-sign": 10
}, /*#__PURE__*/React.createElement("title", null, "\u0412\u043E\u0434\u043E\u043B\u0435\u0439"), /*#__PURE__*/React.createElement("line", {
  x1: 484.77052953216327,
  y1: 146.8339090516312,
  x2: 507.8668457236837,
  y2: 127.6881476830851
}), /*#__PURE__*/React.createElement("use", {
  href: "#R0-g32",
  x: 436.50934532406086,
  y: 80.99520908866796,
  width: 22,
  height: 22,
  "aria-hidden": "true"
}))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
  className: "zodiac-sign",
  "data-sign": 11
}, /*#__PURE__*/React.createElement("title", null, "\u0420\u044B\u0431\u044B"), /*#__PURE__*/React.createElement("line", {
  x1: 383.43292697137184,
  y1: 74.96900947427321,
  x2: 393.8620428427933,
  y2: 46.84013565855736
}), /*#__PURE__*/React.createElement("use", {
  href: "#R0-g33",
  x: 312.74444489058203,
  y: 35.107894299885515,
  width: 22,
  height: 22,
  "aria-hidden": "true"
}))), _line || (_line = /*#__PURE__*/React.createElement("line", {
  className: "degree-tick major",
  x1: 259.90729092724297,
  y1: 64.38681132159164,
  x2: 261.4170582145016,
  y2: 73.2592744935819
})), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
  className: "degree-tick ",
  x1: 255.8013801102282,
  y1: 65.12241060535499,
  x2: 256.35617450215,
  y2: 68.07066486553882
})), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
  className: "degree-tick ",
  x1: 251.70893262099355,
  y1: 65.9295558781582,
  x2: 252.31509664667146,
  y2: 68.86767860772107
})), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
  className: "degree-tick ",
  x1: 247.63119505868855,
  y1: 66.80800127573227,
  x2: 248.28854407468828,
  y2: 69.73509749402854
})), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
  className: "degree-tick ",
  x1: 243.5694095416767,
  y1: 67.75747921509938,
  x2: 244.27774331312008,
  y2: 70.67265730026551
})), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
  className: "degree-tick ",
  x1: 239.5248133291738,
  y1: 68.7777004760814,
  x2: 241.04301885229077,
  y2: 74.58244439718396
})), _line7 || (_line7 = /*#__PURE__*/React.createElement("line", {
  className: "degree-tick ",
  x1: 235.4986384443672,
  y1: 69.8683542893991,
  x2: 236.30827896598603,
  y2: 72.75703603472044
})), _line8 || (_line8 = /*#__PURE__*/React.createElement("line", {
  className: "degree-tick ",
  x1: 231.49211129912914,
  y1: 71.02910843133554,
  x2: 232.35204295646224,
  y2: 73.90322004098405
})), _line9 || (_line9 = /*#__PURE__*/React.createElement("line", {
  className: "degree-tick ",
  x1: 227.50645232044025,
  y1: 72.25960932493464,
  x2: 228.41641316997448,
  y2: 75.11827531667186
})), _line0 || (_line0 = /*#__PURE__*/React.createElement("line", {
  className: "degree-tick ",
  x1: 223.54287557863523,
  y1: 73.55948214770407,
  x2: 224.50258843748082,
  y2: 76.4018317441764
})), _line1 || (_line1 = /*#__PURE__*/React.createElement("line", {
  className: "degree-tick major",
  x1: 219.6025884175858,
  y1: 74.92833094578987,
  x2: 222.63010600855537,
  y2: 83.40383312774756
})), _line10 || (_line10 = /*#__PURE__*/React.createElement("line", {
  className: "degree-tick ",
  x1: 215.68679108693152,
  y1: 76.36573875458782,
  x2: 216.7451158850035,
  y2: 79.17286337273106
})), _line11 || (_line11 = /*#__PURE__*/React.createElement("line", {
  className: "degree-tick ",
  x1: 211.79667637647265,
  y1: 77.87126772575482,
  x2: 212.9038310663077,
  y2: 80.65949449070351
})), _line12 || (_line12 = /*#__PURE__*/React.createElement("line", {
  className: "degree-tick ",
  x1: 207.93342925283423,
  y1: 79.44445926058191,
  x2: 209.0890765843886,
  y2: 82.21293885145326
})), _line13 || (_line13 = /*#__PURE__*/React.createElement("line", {
  className: "degree-tick ",
  x1: 204.0982264985143,
  y1: 81.08483414968771,
  x2: 205.30201445041578,
  y2: 83.83272326077949
})), _line14 || (_line14 = /*#__PURE__*/React.createElement("line", {
  className: "degree-tick ",
  x1: 200.2922363534243,
  y1: 82.79189271899034,
  x2: 202.7953601269785,
  y2: 88.24481591432951
})), _line15 || (_line15 = /*#__PURE__*/React.createElement("line", {
  className: "degree-tick ",
  x1: 196.51661815903174,
  y1: 84.56511498191301,
  x2: 197.8155727428096,
  y2: 87.2693185595459
})), _line16 || (_line16 = /*#__PURE__*/React.createElement("line", {
  className: "degree-tick ",
  x1: 192.7725220052141,
  y1: 86.40396079777673,
  x2: 194.11847361184323,
  y2: 89.08508262876697
})), _line17 || (_line17 = /*#__PURE__*/React.createElement("line", {
  className: "degree-tick ",
  x1: 189.06108837992946,
  y1: 88.30787003633279,
  x2: 190.45362701951194,
  y2: 90.96509342499806
})), _line18 || (_line18 = /*#__PURE__*/React.createElement("line", {
  className: "degree-tick ",
  x1: 185.38344782181377,
  y1: 90.27626274838343,
  x2: 186.82214931359016,
  y2: 92.90877827873845
})), _line19 || (_line19 = /*#__PURE__*/React.createElement("line", {
  className: "degree-tick major",
  x1: 181.74072057580702,
  y1: 92.30853934244035,
  x2: 186.19399888048372,
  y2: 100.12955668937775
})), _line20 || (_line20 = /*#__PURE__*/React.createElement("line", {
  className: "degree-tick ",
  x1: 178.13401625191614,
  y1: 94.404080767366,
  x2: 179.66371479268707,
  y2: 96.98478268241999
})), _line21 || (_line21 = /*#__PURE__*/React.createElement("line", {
  className: "degree-tick ",
  x1: 174.56443348721723,
  y1: 96.56224870094232,
  x2: 176.1389385062061,
  y2: 99.11586064193469
})), _line22 || (_line22 = /*#__PURE__*/React.createElement("line", {
  className: "degree-tick ",
  x1: 171.0330596111998,
  y1: 98.78238574431,
  x2: 172.65189149892535,
  y2: 101.3081298563061
})), _line23 || (_line23 = /*#__PURE__*/React.createElement("line", {
  className: "degree-tick ",
  x1: 167.54097031455564,
  y1: 101.06381562221878,
  x2: 169.2036359591428,
  y2: 103.56092253909469
})), _line24 || (_line24 = /*#__PURE__*/React.createElement("line", {
  className: "degree-tick ",
  x1: 164.089229321513,
  y1: 103.40584338902718,
  x2: 167.50121519628672,
  y2: 108.34126154662482
})), _line25 || (_line25 = /*#__PURE__*/React.createElement("line", {
  className: "degree-tick ",
  x1: 160.6788880658163,
  y1: 105.80775564038956,
  x2: 162.4276886340278,
  y2: 108.24531519302064
})), _line26 || (_line26 = /*#__PURE__*/React.createElement("line", {
  className: "degree-tick ",
  x1: 157.31098537044858,
  y1: 108.26882073056649,
  x2: 159.10206086789066,
  y2: 110.67548825277694
})), _line27 || (_line27 = /*#__PURE__*/React.createElement("line", {
  className: "degree-tick ",
  x1: 153.98654713119663,
  y1: 110.7882889952904,
  x2: 155.81935197892219,
  y2: 113.16333139283904
})), _line28 || (_line28 = /*#__PURE__*/React.createElement("line", {
  className: "degree-tick ",
  x1: 150.70658600415254,
  y1: 113.36539298012144,
  x2: 152.5805619120502,
  y2: 115.70808679208645
})), _line29 || (_line29 = /*#__PURE__*/React.createElement("line", {
  className: "degree-tick major",
  x1: 147.4721010972494,
  y1: 115.99934767422076,
  x2: 153.21582950781323,
  y2: 122.92824253167689
})), _line30 || (_line30 = /*#__PURE__*/React.createElement("line", {
  className: "degree-tick ",
  x1: 144.284077665923,
  y1: 118.6893507494728,
  x2: 146.23867083329637,
  y2: 120.96521663964677
})), _line31 || (_line31 = /*#__PURE__*/React.createElement("line", {
  className: "degree-tick ",
  x1: 141.14348681299347,
  y1: 121.43458280488233,
  x2: 143.13750162287224,
  y2: 123.67598971528128
})), _line32 || (_line32 = /*#__PURE__*/React.createElement("line", {
  className: "degree-tick ",
  x1: 138.05128519285836,
  y1: 124.23420761617155,
  x2: 140.08411424901493,
  y2: 126.44047279253758
})), _line33 || (_line33 = /*#__PURE__*/React.createElement("line", {
  className: "degree-tick ",
  x1: 135.00841472008594,
  y1: 127.08737239050222,
  x2: 137.07943880309742,
  y2: 129.25782378309006
})), _line34 || (_line34 = /*#__PURE__*/React.createElement("line", {
  className: "degree-tick ",
  x1: 132.0158022824992,
  y1: 129.99320802624504,
  x2: 136.23297879423563,
  y2: 134.26116096282465
})), _line35 || (_line35 = /*#__PURE__*/React.createElement("line", {
  className: "degree-tick ",
  x1: 129.0743594588366,
  y1: 132.95082937771588,
  x2: 131.21986959115247,
  y2: 135.0476808918031
})), _line36 || (_line36 = /*#__PURE__*/React.createElement("line", {
  className: "degree-tick ",
  x1: 126.18498224107668,
  y1: 135.95933552479994,
  x2: 128.36676070666985,
  y2: 138.01842336340076
})), _line37 || (_line37 = /*#__PURE__*/React.createElement("line", {
  className: "degree-tick ",
  x1: 123.3485507615101,
  y1: 139.01781004738064,
  x2: 125.5659329695246,
  y2: 141.0385069923926
})), _line38 || (_line38 = /*#__PURE__*/React.createElement("line", {
  className: "degree-tick ",
  x1: 120.56592902464254,
  y1: 142.12532130449043,
  x2: 122.8182395389776,
  y2: 144.10701183204912
})), _line39 || (_line39 = /*#__PURE__*/React.createElement("line", {
  className: "degree-tick major",
  x1: 117.83796464401101,
  y1: 145.2809227180972,
  x2: 124.69762287917376,
  y2: 151.10716412201822
})), _line40 || (_line40 = /*#__PURE__*/React.createElement("line", {
  className: "degree-tick ",
  x1: 115.16548858399204,
  y1: 148.4836530614415,
  x2: 117.48558705364906,
  y2: 150.38553189330622
})), _line41 || (_line41 = /*#__PURE__*/React.createElement("line", {
  className: "degree-tick ",
  x1: 112.54931490668264,
  y1: 151.73253675183497,
  x2: 114.90225237647323,
  y2: 153.5936346168747
})), _line42 || (_line42 = /*#__PURE__*/React.createElement("line", {
  className: "degree-tick ",
  x1: 109.9902405239281,
  y1: 155.02658414783312,
  x2: 112.37530026630557,
  y2: 156.84633413760926
})), _line43 || (_line43 = /*#__PURE__*/React.createElement("line", {
  className: "degree-tick ",
  x1: 107.48904495457595,
  y1: 158.3647918506888,
  x2: 109.90550045723819,
  y2: 160.14263965172614
})), _line44 || (_line44 = /*#__PURE__*/React.createElement("line", {
  className: "degree-tick ",
  x1: 105.04649008702603,
  y1: 161.74614300999784,
  x2: 109.94072046141031,
  y2: 165.21695113526985
})), _line45 || (_line45 = /*#__PURE__*/React.createElement("line", {
  className: "degree-tick ",
  x1: 102.66331994715276,
  y1: 165.1696076334412,
  x2: 105.14034940388305,
  y2: 166.8620393367871
})), _line46 || (_line46 = /*#__PURE__*/React.createElement("line", {
  className: "degree-tick ",
  x1: 100.34026047166691,
  y1: 168.63414290053072,
  x2: 102.84644967076733,
  y2: 170.28308671349475
})), _line47 || (_line47 = /*#__PURE__*/React.createElement("line", {
  className: "degree-tick ",
  x1: 98.07801928698868,
  y1: 172.13869348026248,
  x2: 100.61260481895116,
  y2: 173.74364711858553
})), _line48 || (_line48 = /*#__PURE__*/React.createElement("line", {
  className: "degree-tick ",
  x1: 95.87728549369777,
  y1: 175.6821918525804,
  x2: 98.43949529921619,
  y2: 177.2426664318367
})), _line49 || (_line49 = /*#__PURE__*/React.createElement("line", {
  className: "degree-tick major",
  x1: 93.73872945662666,
  y1: 179.2635586335536,
  x2: 101.50589027206752,
  y2: 183.8101191871018
})), _line50 || (_line50 = /*#__PURE__*/React.createElement("line", {
  className: "degree-tick ",
  x1: 91.66300260066086,
  y1: 182.8817029041672,
  x2: 94.27811135462747,
  y2: 184.35180705181364
})), _line51 || (_line51 = /*#__PURE__*/React.createElement("line", {
  className: "degree-tick ",
  x1: 89.65073721230866,
  y1: 186.53552254262672,
  x2: 92.29110452763533,
  y2: 187.95976284543895
})), _line52 || (_line52 = /*#__PURE__*/React.createElement("line", {
  className: "degree-tick ",
  x1: 87.70254624710066,
  y1: 190.2239045600748,
  x2: 90.36736784232534,
  y2: 191.60184718065966
})), _line53 || (_line53 = /*#__PURE__*/React.createElement("line", {
  className: "degree-tick ",
  x1: 85.81902314287746,
  y1: 193.94572543961874,
  x2: 88.50748728752751,
  y2: 195.27695064330553
})), _line54 || (_line54 = /*#__PURE__*/React.createElement("line", {
  className: "degree-tick ",
  x1: 84.00074163902264,
  y1: 197.69985147856454,
  x2: 89.42331716272918,
  y2: 200.26805604395622
})), _line55 || (_line55 = /*#__PURE__*/React.createElement("line", {
  className: "degree-tick ",
  x1: 82.24825560169631,
  y1: 201.4851391337539,
  x2: 84.9815410962357,
  y2: 202.7217273454641
})), _line56 || (_line56 = /*#__PURE__*/React.createElement("line", {
  className: "degree-tick ",
  x1: 80.56209885512231,
  y1: 205.3004353698979,
  x2: 83.31654949710821,
  y2: 206.48913283387407
})), _line57 || (_line57 = /*#__PURE__*/React.createElement("line", {
  className: "degree-tick ",
  x1: 78.94278501897969,
  y1: 209.1445780108035,
  x2: 81.71756177606363,
  y2: 210.28502263828295
})), _line58 || (_line58 = /*#__PURE__*/React.createElement("line", {
  className: "degree-tick ",
  x1: 77.39080735194958,
  y1: 213.01639609338338,
  x2: 80.18506500025146,
  y2: 214.1082404938848
})), _line59 || (_line59 = /*#__PURE__*/React.createElement("line", {
  className: "degree-tick major",
  x1: 75.90663860146375,
  y1: 216.91471022434226,
  x2: 84.34530074617851,
  y2: 220.0434449857687
})), _line60 || (_line60 = /*#__PURE__*/React.createElement("line", {
  className: "degree-tick ",
  x1: 74.49073085970107,
  y1: 220.838332939432,
  x2: 77.32139114179688,
  y2: 221.83199403224248
})), _line61 || (_line61 = /*#__PURE__*/React.createElement("line", {
  className: "degree-tick ",
  x1: 73.14351542587588,
  y1: 224.78606906516467,
  x2: 75.99108636195274,
  y2: 225.7301769848488
})), _line62 || (_line62 = /*#__PURE__*/React.createElement("line", {
  className: "degree-tick ",
  x1: 71.86540267486006,
  y1: 228.75671608287382,
  x2: 74.72901686722582,
  y2: 229.6509832450135
})), _line63 || (_line63 = /*#__PURE__*/React.createElement("line", {
  className: "degree-tick ",
  x1: 70.65678193217892,
  y1: 232.74906449501339,
  x2: 73.53556709621014,
  y2: 233.59321849716804
})), _line64 || (_line64 = /*#__PURE__*/React.createElement("line", {
  className: "degree-tick ",
  x1: 69.51802135541888,
  y1: 236.76189819358225,
  x2: 75.30417981511548,
  y2: 238.34946560294838
})), _line65 || (_line65 = /*#__PURE__*/React.createElement("line", {
  className: "degree-tick ",
  x1: 68.44946782208311,
  y1: 240.79399483056247,
  x2: 71.35595985778917,
  y2: 241.53716644356797
})), _line66 || (_line66 = /*#__PURE__*/React.createElement("line", {
  className: "degree-tick ",
  x1: 67.45144682392905,
  y1: 244.84412619025875,
  x2: 70.37046631986297,
  y2: 245.5364593343141
})), _line67 || (_line67 = /*#__PURE__*/React.createElement("line", {
  className: "degree-tick ",
  x1: 66.52426236782082,
  y1: 248.91105856342455,
  x2: 69.45492016236702,
  y2: 249.55234234714723
})), _line68 || (_line68 = /*#__PURE__*/React.createElement("line", {
  className: "degree-tick ",
  x1: 65.66819688312566,
  y1: 252.99355312306147,
  x2: 68.60960026952995,
  y2: 253.58359220519878
})), _line69 || (_line69 = /*#__PURE__*/React.createElement("line", {
  className: "degree-tick major",
  x1: 64.88351113568305,
  y1: 257.09036630177883,
  x2: 73.73727013057365,
  y2: 258.70621024857377
})), _line70 || (_line70 = /*#__PURE__*/React.createElement("line", {
  className: "degree-tick ",
  x1: 64.17044414837304,
  y1: 261.2002501705957,
  x2: 67.13064777830976,
  y2: 261.68727631908195
})), _line71 || (_line71 = /*#__PURE__*/React.createElement("line", {
  className: "degree-tick ",
  x1: 63.529213128307646,
  y1: 265.32195281907224,
  x2: 66.49746568318244,
  y2: 265.75724211423034
})), _line72 || (_line72 = /*#__PURE__*/React.createElement("line", {
  className: "degree-tick ",
  x1: 62.96001340066735,
  y1: 269.45421873665384,
  x2: 65.93541072199787,
  y2: 269.8376385851477
})), _line73 || (_line73 = /*#__PURE__*/React.createElement("line", {
  className: "degree-tick ",
  x1: 62.46301834920311,
  y1: 273.5957891951118,
  x2: 65.44465410214198,
  y2: 273.9272228035414
})), _line74 || (_line74 = /*#__PURE__*/React.createElement("line", {
  className: "degree-tick ",
  x1: 62.03837936342211,
  y1: 277.7454026319643,
  x2: 68.01231126224832,
  y2: 278.30409545291917
})), _line75 || (_line75 = /*#__PURE__*/React.createElement("line", {
  className: "degree-tick ",
  x1: 61.68622579247298,
  y1: 281.9017950347603,
  x2: 64.67761207959674,
  y2: 282.1289691556629
})), _line76 || (_line76 = /*#__PURE__*/React.createElement("line", {
  className: "degree-tick ",
  x1: 61.40666490574483,
  y1: 286.0637003261098,
  x2: 64.40156032533798,
  y2: 286.2386329579997
})), _line77 || (_line77 = /*#__PURE__*/React.createElement("line", {
  className: "degree-tick ",
  x1: 61.19978186019196,
  y1: 290.22985074934405,
  x2: 64.1972741380975,
  y2: 290.35248860604685
})), _line78 || (_line78 = /*#__PURE__*/React.createElement("line", {
  className: "degree-tick ",
  x1: 61.065639674394106,
  y1: 294.39897725468563,
  x2: 64.06481574542681,
  y2: 294.46928297952223
})), _line79 || (_line79 = /*#__PURE__*/React.createElement("line", {
  className: "degree-tick major",
  x1: 61.00427920936056,
  y1: 298.5698098858137,
  x2: 70.00411806758547,
  y2: 298.62366641731023
})), _line80 || (_line80 = /*#__PURE__*/React.createElement("line", {
  className: "degree-tick ",
  x1: 61.01571915608338,
  y1: 302.7410781667053,
  x2: 64.01552184450074,
  y2: 302.70667132779266
})), _line81 || (_line81 = /*#__PURE__*/React.createElement("line", {
  className: "degree-tick ",
  x1: 61.09995602984395,
  y1: 306.9115114886338,
  x2: 64.09870135164508,
  y2: 306.8247561142994
})), _line82 || (_line82 = /*#__PURE__*/React.createElement("line", {
  className: "degree-tick ",
  x1: 61.25696417127455,
  y1: 311.0798394972094,
  x2: 64.25373867958493,
  y2: 310.9407620139808
})), _line83 || (_line83 = /*#__PURE__*/React.createElement("line", {
  className: "degree-tick ",
  x1: 61.48669575417432,
  y1: 315.24479247934136,
  x2: 64.48058660244826,
  y2: 315.05343525156724
})), _line84 || (_line84 = /*#__PURE__*/React.createElement("line", {
  className: "degree-tick ",
  x1: 61.789080800077585,
  y1: 319.40510175000463,
  x2: 67.769271240243,
  y2: 318.9179443838957
})), _line85 || (_line85 = /*#__PURE__*/React.createElement("line", {
  className: "degree-tick ",
  x1: 62.16402719957014,
  y1: 323.5595000386933,
  x2: 65.14941597949183,
  y2: 323.263774096785
})), _line86 || (_line86 = /*#__PURE__*/React.createElement("line", {
  className: "degree-tick ",
  x1: 62.61142074034652,
  y1: 327.70672187544415,
  x2: 65.59119370176475,
  y2: 327.3589387556687
})), _line87 || (_line87 = /*#__PURE__*/React.createElement("line", {
  className: "degree-tick ",
  x1: 63.1311251420002,
  y1: 331.84550397631074,
  x2: 66.10437461720522,
  y2: 331.44576961677546
})), _line88 || (_line88 = /*#__PURE__*/React.createElement("line", {
  className: "degree-tick ",
  x1: 63.72298209753592,
  y1: 335.9745856281719,
  x2: 66.68880240593504,
  y2: 335.523021791835
})), _line89 || (_line89 = /*#__PURE__*/React.createElement("line", {
  className: "degree-tick major",
  x1: 64.38681132159161,
  y1: 340.092709072757,
  x2: 73.25927449358187,
  y2: 338.58294178549835
})), _line90 || (_line90 = /*#__PURE__*/React.createElement("line", {
  className: "degree-tick ",
  x1: 65.12241060535499,
  y1: 344.1986198897719,
  x2: 68.07066486553882,
  y2: 343.64382549785006
})), _line91 || (_line91 = /*#__PURE__*/React.createElement("line", {
  className: "degree-tick ",
  x1: 65.92955587815823,
  y1: 348.29106737900656,
  x2: 68.8676786077211,
  y2: 347.68490335332865
})), _line92 || (_line92 = /*#__PURE__*/React.createElement("line", {
  className: "degree-tick ",
  x1: 66.8080012757323,
  y1: 352.3688049413115,
  x2: 69.73509749402857,
  y2: 351.7114559253118
})), _line93 || (_line93 = /*#__PURE__*/React.createElement("line", {
  className: "degree-tick ",
  x1: 67.75747921509941,
  y1: 356.4305904583234,
  x2: 70.67265730026554,
  y2: 355.72225668688003
})), _line94 || (_line94 = /*#__PURE__*/React.createElement("line", {
  className: "degree-tick ",
  x1: 68.7777004760814,
  y1: 360.4751866708262,
  x2: 74.58244439718396,
  y2: 358.95698114770926
})), _line95 || (_line95 = /*#__PURE__*/React.createElement("line", {
  className: "degree-tick ",
  x1: 69.8683542893991,
  y1: 364.5013615556328,
  x2: 72.75703603472044,
  y2: 363.69172103401394
})), _line96 || (_line96 = /*#__PURE__*/React.createElement("line", {
  className: "degree-tick ",
  x1: 71.02910843133557,
  y1: 368.50788870087086,
  x2: 73.90322004098408,
  y2: 367.64795704353776
})), _line97 || (_line97 = /*#__PURE__*/React.createElement("line", {
  className: "degree-tick ",
  x1: 72.25960932493464,
  y1: 372.4935476795598,
  x2: 75.11827531667186,
  y2: 371.5835868300256
})), _line98 || (_line98 = /*#__PURE__*/React.createElement("line", {
  className: "degree-tick ",
  x1: 73.5594821477041,
  y1: 376.4571244213648,
  x2: 76.40183174417643,
  y2: 375.49741156251923
})), _line99 || (_line99 = /*#__PURE__*/React.createElement("line", {
  className: "degree-tick major",
  x1: 74.9283309457899,
  y1: 380.39741158241424,
  x2: 83.40383312774759,
  y2: 377.36989399144466
})), _line100 || (_line100 = /*#__PURE__*/React.createElement("line", {
  className: "degree-tick ",
  x1: 76.36573875458785,
  y1: 384.31320891306854,
  x2: 79.17286337273109,
  y2: 383.25488411499657
})), _line101 || (_line101 = /*#__PURE__*/React.createElement("line", {
  className: "degree-tick ",
  x1: 77.87126772575482,
  y1: 388.2033236235274,
  x2: 80.65949449070351,
  y2: 387.09616893369235
})), _line102 || (_line102 = /*#__PURE__*/React.createElement("line", {
  className: "degree-tick ",
  x1: 79.44445926058188,
  y1: 392.06657074716577,
  x2: 82.21293885145323,
  y2: 390.91092341561136
})), _line103 || (_line103 = /*#__PURE__*/React.createElement("line", {
  className: "degree-tick ",
  x1: 81.08483414968774,
  y1: 395.90177350148576,
  x2: 83.83272326077952,
  y2: 394.69798554958425
})), _line104 || (_line104 = /*#__PURE__*/React.createElement("line", {
  className: "degree-tick ",
  x1: 82.7918927189904,
  y1: 399.7077636465758,
  x2: 88.24481591432956,
  y2: 397.2046398730216
})), _line105 || (_line105 = /*#__PURE__*/React.createElement("line", {
  className: "degree-tick ",
  x1: 84.56511498191304,
  y1: 403.48338184096826,
  x2: 87.26931855954592,
  y2: 402.18442725719046
})), _line106 || (_line106 = /*#__PURE__*/React.createElement("line", {
  className: "degree-tick ",
  x1: 86.40396079777673,
  y1: 407.22747799478594,
  x2: 89.085082628767,
  y2: 405.88152638815683
})), _line107 || (_line107 = /*#__PURE__*/React.createElement("line", {
  className: "degree-tick ",
  x1: 88.30787003633279,
  y1: 410.9389116200706,
  x2: 90.96509342499806,
  y2: 409.5463729804881
})), _line108 || (_line108 = /*#__PURE__*/React.createElement("line", {
  className: "degree-tick ",
  x1: 90.27626274838346,
  y1: 414.61655217818634,
  x2: 92.90877827873848,
  y2: 413.17785068641
})), _line109 || (_line109 = /*#__PURE__*/React.createElement("line", {
  className: "degree-tick major",
  x1: 92.30853934244044,
  y1: 418.2592794241931,
  x2: 100.12955668937784,
  y2: 413.8060011195164
})), _line110 || (_line110 = /*#__PURE__*/React.createElement("line", {
  className: "degree-tick ",
  x1: 94.40408076736603,
  y1: 421.8659837480839,
  x2: 96.98478268242002,
  y2: 420.336285207313
})), _line111 || (_line111 = /*#__PURE__*/React.createElement("line", {
  className: "degree-tick ",
  x1: 96.56224870094226,
  y1: 425.4355665127827,
  x2: 99.11586064193463,
  y2: 423.86106149379384
})), _line112 || (_line112 = /*#__PURE__*/React.createElement("line", {
  className: "degree-tick ",
  x1: 98.78238574431003,
  y1: 428.96694038880025,
  x2: 101.30812985630612,
  y2: 427.3481085010747
})), _line113 || (_line113 = /*#__PURE__*/React.createElement("line", {
  className: "degree-tick ",
  x1: 101.06381562221878,
  y1: 432.4590296854444,
  x2: 103.56092253909469,
  y2: 430.7963640408572
})), _line114 || (_line114 = /*#__PURE__*/React.createElement("line", {
  className: "degree-tick ",
  x1: 103.40584338902718,
  y1: 435.91077067848704,
  x2: 108.34126154662482,
  y2: 432.4987848037133
})), _line115 || (_line115 = /*#__PURE__*/React.createElement("line", {
  className: "degree-tick ",
  x1: 105.80775564038959,
  y1: 439.3211119341837,
  x2: 108.24531519302067,
  y2: 437.57231136597227
})), _line116 || (_line116 = /*#__PURE__*/React.createElement("line", {
  className: "degree-tick ",
  x1: 108.26882073056649,
  y1: 442.6890146295515,
  x2: 110.67548825277697,
  y2: 440.8979391321094
})), _line117 || (_line117 = /*#__PURE__*/React.createElement("line", {
  className: "degree-tick ",
  x1: 110.78828899529046,
  y1: 446.01345286880337,
  x2: 113.1633313928391,
  y2: 444.18064802107784
})), _line118 || (_line118 = /*#__PURE__*/React.createElement("line", {
  className: "degree-tick ",
  x1: 113.36539298012141,
  y1: 449.29341399584746,
  x2: 115.70808679208642,
  y2: 447.41943808794974
})), _line119 || (_line119 = /*#__PURE__*/React.createElement("line", {
  className: "degree-tick major",
  x1: 115.99934767422079,
  y1: 452.5278989027506,
  x2: 122.92824253167691,
  y2: 446.7841704921868
})), _line120 || (_line120 = /*#__PURE__*/React.createElement("line", {
  className: "degree-tick ",
  x1: 118.68935074947288,
  y1: 455.7159223340771,
  x2: 120.96521663964688,
  y2: 453.7613291667037
})), _line121 || (_line121 = /*#__PURE__*/React.createElement("line", {
  className: "degree-tick ",
  x1: 121.43458280488235,
  y1: 458.85651318700656,
  x2: 123.6759897152813,
  y2: 456.8624983771278
})), _line122 || (_line122 = /*#__PURE__*/React.createElement("line", {
  className: "degree-tick ",
  x1: 124.23420761617149,
  y1: 461.94871480714164,
  x2: 126.44047279253752,
  y2: 459.915885750985
})), _line123 || (_line123 = /*#__PURE__*/React.createElement("line", {
  className: "degree-tick ",
  x1: 127.08737239050225,
  y1: 464.9915852799141,
  x2: 129.2578237830901,
  y2: 462.9205611969026
})), _line124 || (_line124 = /*#__PURE__*/React.createElement("line", {
  className: "degree-tick ",
  x1: 129.99320802624513,
  y1: 467.98419771750093,
  x2: 134.26116096282476,
  y2: 463.7670212057645
})), _line125 || (_line125 = /*#__PURE__*/React.createElement("line", {
  className: "degree-tick ",
  x1: 132.9508293777159,
  y1: 470.9256405411635,
  x2: 135.04768089180314,
  y2: 468.7801304088476
})), _line126 || (_line126 = /*#__PURE__*/React.createElement("line", {
  className: "degree-tick ",
  x1: 135.95933552479988,
  y1: 473.81501775892326,
  x2: 138.01842336340073,
  y2: 471.6332392933301
})), _line127 || (_line127 = /*#__PURE__*/React.createElement("line", {
  className: "degree-tick ",
  x1: 139.01781004738066,
  y1: 476.65144923848993,
  x2: 141.03850699239263,
  y2: 474.4340670304754
})), _line128 || (_line128 = /*#__PURE__*/React.createElement("line", {
  className: "degree-tick ",
  x1: 142.12532130449046,
  y1: 479.4340709753575,
  x2: 144.10701183204915,
  y2: 477.18176046102246
})), _line129 || (_line129 = /*#__PURE__*/React.createElement("line", {
  className: "degree-tick major",
  x1: 145.28092271809723,
  y1: 482.162035355989,
  x2: 151.10716412201825,
  y2: 475.30237712082624
})), _line130 || (_line130 = /*#__PURE__*/React.createElement("line", {
  className: "degree-tick ",
  x1: 148.48365306144152,
  y1: 484.834511416008,
  x2: 150.38553189330628,
  y2: 482.51441294635094
})), _line131 || (_line131 = /*#__PURE__*/React.createElement("line", {
  className: "degree-tick ",
  x1: 151.7325367518351,
  y1: 487.4506850933175,
  x2: 153.59363461687485,
  y2: 485.09774762352686
})), _line132 || (_line132 = /*#__PURE__*/React.createElement("line", {
  className: "degree-tick ",
  x1: 155.02658414783318,
  y1: 490.00975947607196,
  x2: 156.84633413760932,
  y2: 487.62469973369446
})), _line133 || (_line133 = /*#__PURE__*/React.createElement("line", {
  className: "degree-tick ",
  x1: 158.3647918506888,
  y1: 492.5109550454241,
  x2: 160.14263965172617,
  y2: 490.09449954276187
})), _line134 || (_line134 = /*#__PURE__*/React.createElement("line", {
  className: "degree-tick ",
  x1: 161.74614300999778,
  y1: 494.9535099129739,
  x2: 165.21695113526982,
  y2: 490.05927953858964
})), _line135 || (_line135 = /*#__PURE__*/React.createElement("line", {
  className: "degree-tick ",
  x1: 165.16960763344125,
  y1: 497.3366800528472,
  x2: 166.86203933678715,
  y2: 494.8596505961169
})), _line136 || (_line136 = /*#__PURE__*/React.createElement("line", {
  className: "degree-tick ",
  x1: 168.63414290053083,
  y1: 499.65973952833315,
  x2: 170.2830867134949,
  y2: 497.15355032923276
})), _line137 || (_line137 = /*#__PURE__*/React.createElement("line", {
  className: "degree-tick ",
  x1: 172.13869348026248,
  y1: 501.92198071301135,
  x2: 173.74364711858556,
  y2: 499.3873951810489
})), _line138 || (_line138 = /*#__PURE__*/React.createElement("line", {
  className: "degree-tick ",
  x1: 175.68219185258033,
  y1: 504.1227145063022,
  x2: 177.24266643183665,
  y2: 501.5605047007838
})), _line139 || (_line139 = /*#__PURE__*/React.createElement("line", {
  className: "degree-tick major",
  x1: 179.26355863355366,
  y1: 506.26127054337337,
  x2: 183.81011918710186,
  y2: 498.4941097279325
})), _line140 || (_line140 = /*#__PURE__*/React.createElement("line", {
  className: "degree-tick ",
  x1: 182.88170290416735,
  y1: 508.3369973993392,
  x2: 184.35180705181378,
  y2: 505.7218886453726
})), _line141 || (_line141 = /*#__PURE__*/React.createElement("line", {
  className: "degree-tick ",
  x1: 186.53552254262678,
  y1: 510.3492627876914,
  x2: 187.95976284543897,
  y2: 507.7088954723647
})), _line142 || (_line142 = /*#__PURE__*/React.createElement("line", {
  className: "degree-tick ",
  x1: 190.22390456007474,
  y1: 512.2974537528993,
  x2: 191.6018471806596,
  y2: 509.6326321576746
})), _line143 || (_line143 = /*#__PURE__*/React.createElement("line", {
  className: "degree-tick ",
  x1: 193.94572543961874,
  y1: 514.1809768571226,
  x2: 195.27695064330555,
  y2: 511.4925127124725
})), _line144 || (_line144 = /*#__PURE__*/React.createElement("line", {
  className: "degree-tick ",
  x1: 197.6998514785646,
  y1: 515.9992583609774,
  x2: 200.26805604395628,
  y2: 510.5766828372708
})), _line145 || (_line145 = /*#__PURE__*/React.createElement("line", {
  className: "degree-tick ",
  x1: 201.4851391337539,
  y1: 517.7517443983037,
  x2: 202.7217273454641,
  y2: 515.0184589037642
})), _line146 || (_line146 = /*#__PURE__*/React.createElement("line", {
  className: "degree-tick ",
  x1: 205.30043536989797,
  y1: 519.4379011448777,
  x2: 206.48913283387418,
  y2: 516.6834505028919
})), _line147 || (_line147 = /*#__PURE__*/React.createElement("line", {
  className: "degree-tick ",
  x1: 209.1445780108036,
  y1: 521.0572149810204,
  x2: 210.28502263828307,
  y2: 518.2824382239364
})), _line148 || (_line148 = /*#__PURE__*/React.createElement("line", {
  className: "degree-tick ",
  x1: 213.0163960933834,
  y1: 522.6091926480505,
  x2: 214.10824049388486,
  y2: 519.8149349997486
})), _line149 || (_line149 = /*#__PURE__*/React.createElement("line", {
  className: "degree-tick major",
  x1: 216.91471022434223,
  y1: 524.0933613985362,
  x2: 220.0434449857687,
  y2: 515.6546992538215
})), _line150 || (_line150 = /*#__PURE__*/React.createElement("line", {
  className: "degree-tick ",
  x1: 220.838332939432,
  y1: 525.5092691402989,
  x2: 221.83199403224248,
  y2: 522.6786088582031
})), _line151 || (_line151 = /*#__PURE__*/React.createElement("line", {
  className: "degree-tick ",
  x1: 224.78606906516478,
  y1: 526.8564845741241,
  x2: 225.7301769848489,
  y2: 524.0089136380473
})), _line152 || (_line152 = /*#__PURE__*/React.createElement("line", {
  className: "degree-tick ",
  x1: 228.75671608287396,
  y1: 528.13459732514,
  x2: 229.6509832450136,
  y2: 525.2709831327742
})), _line153 || (_line153 = /*#__PURE__*/React.createElement("line", {
  className: "degree-tick ",
  x1: 232.74906449501344,
  y1: 529.3432180678211,
  x2: 233.5932184971681,
  y2: 526.4644329037899
})), _line154 || (_line154 = /*#__PURE__*/React.createElement("line", {
  className: "degree-tick ",
  x1: 236.76189819358223,
  y1: 530.4819786445811,
  x2: 238.34946560294838,
  y2: 524.6958201848845
})), _line155 || (_line155 = /*#__PURE__*/React.createElement("line", {
  className: "degree-tick ",
  x1: 240.7939948305625,
  y1: 531.5505321779169,
  x2: 241.537166443568,
  y2: 528.6440401422109
})), _line156 || (_line156 = /*#__PURE__*/React.createElement("line", {
  className: "degree-tick ",
  x1: 244.8441261902589,
  y1: 532.548553176071,
  x2: 245.53645933431423,
  y2: 529.629533680137
})), _line157 || (_line157 = /*#__PURE__*/React.createElement("line", {
  className: "degree-tick ",
  x1: 248.91105856342458,
  y1: 533.4757376321792,
  x2: 249.5523423471473,
  y2: 530.545079837633
})), _line158 || (_line158 = /*#__PURE__*/React.createElement("line", {
  className: "degree-tick ",
  x1: 252.9935531230616,
  y1: 534.3318031168744,
  x2: 253.58359220519887,
  y2: 531.3903997304701
})), _line159 || (_line159 = /*#__PURE__*/React.createElement("line", {
  className: "degree-tick major",
  x1: 257.090366301779,
  y1: 535.116488864317,
  x2: 258.70621024857394,
  y2: 526.2627298694264
})), _line160 || (_line160 = /*#__PURE__*/React.createElement("line", {
  className: "degree-tick ",
  x1: 261.2002501705957,
  y1: 535.829555851627,
  x2: 261.687276319082,
  y2: 532.8693522216902
})), _line161 || (_line161 = /*#__PURE__*/React.createElement("line", {
  className: "degree-tick ",
  x1: 265.32195281907224,
  y1: 536.4707868716923,
  x2: 265.7572421142303,
  y2: 533.5025343168176
})), _line162 || (_line162 = /*#__PURE__*/React.createElement("line", {
  className: "degree-tick ",
  x1: 269.45421873665384,
  y1: 537.0399865993327,
  x2: 269.8376385851477,
  y2: 534.0645892780021
})), _line163 || (_line163 = /*#__PURE__*/React.createElement("line", {
  className: "degree-tick ",
  x1: 273.5957891951119,
  y1: 537.5369816507969,
  x2: 273.92722280354144,
  y2: 534.555345897858
})), _line164 || (_line164 = /*#__PURE__*/React.createElement("line", {
  className: "degree-tick ",
  x1: 277.74540263196434,
  y1: 537.9616206365779,
  x2: 278.3040954529192,
  y2: 531.9876887377517
})), _line165 || (_line165 = /*#__PURE__*/React.createElement("line", {
  className: "degree-tick ",
  x1: 281.9017950347603,
  y1: 538.313774207527,
  x2: 282.1289691556629,
  y2: 535.3223879204032
})), _line166 || (_line166 = /*#__PURE__*/React.createElement("line", {
  className: "degree-tick ",
  x1: 286.0637003261098,
  y1: 538.5933350942552,
  x2: 286.2386329579997,
  y2: 535.598439674662
})), _line167 || (_line167 = /*#__PURE__*/React.createElement("line", {
  className: "degree-tick ",
  x1: 290.22985074934417,
  y1: 538.8002181398081,
  x2: 290.3524886060469,
  y2: 535.8027258619024
})), _line168 || (_line168 = /*#__PURE__*/React.createElement("line", {
  className: "degree-tick ",
  x1: 294.3989772546857,
  y1: 538.9343603256059,
  x2: 294.4692829795223,
  y2: 535.9351842545732
})), _line169 || (_line169 = /*#__PURE__*/React.createElement("line", {
  className: "degree-tick major",
  x1: 298.5698098858138,
  y1: 538.9957207906394,
  x2: 298.62366641731035,
  y2: 529.9958819324145
})), _line170 || (_line170 = /*#__PURE__*/React.createElement("line", {
  className: "degree-tick ",
  x1: 302.74107816670517,
  y1: 538.9842808439166,
  x2: 302.70667132779255,
  y2: 535.9844781554992
})), _line171 || (_line171 = /*#__PURE__*/React.createElement("line", {
  className: "degree-tick ",
  x1: 306.91151148863366,
  y1: 538.900043970156,
  x2: 306.8247561142993,
  y2: 535.9012986483549
})), _line172 || (_line172 = /*#__PURE__*/React.createElement("line", {
  className: "degree-tick ",
  x1: 311.0798394972094,
  y1: 538.7430358287254,
  x2: 310.9407620139808,
  y2: 535.7462613204151
})), _line173 || (_line173 = /*#__PURE__*/React.createElement("line", {
  className: "degree-tick ",
  x1: 315.2447924793414,
  y1: 538.5133042458257,
  x2: 315.05343525156724,
  y2: 535.5194133975517
})), _line174 || (_line174 = /*#__PURE__*/React.createElement("line", {
  className: "degree-tick ",
  x1: 319.4051017500046,
  y1: 538.2109191999224,
  x2: 318.91794438389564,
  y2: 532.230728759757
})), _line175 || (_line175 = /*#__PURE__*/React.createElement("line", {
  className: "degree-tick ",
  x1: 323.5595000386933,
  y1: 537.8359728004299,
  x2: 323.26377409678497,
  y2: 534.8505840205082
})), _line176 || (_line176 = /*#__PURE__*/React.createElement("line", {
  className: "degree-tick ",
  x1: 327.70672187544415,
  y1: 537.3885792596535,
  x2: 327.3589387556687,
  y2: 534.4088062982353
})), _line177 || (_line177 = /*#__PURE__*/React.createElement("line", {
  className: "degree-tick ",
  x1: 331.84550397631074,
  y1: 536.8688748579998,
  x2: 331.44576961677546,
  y2: 533.8956253827948
})), _line178 || (_line178 = /*#__PURE__*/React.createElement("line", {
  className: "degree-tick ",
  x1: 335.9745856281719,
  y1: 536.2770179024641,
  x2: 335.523021791835,
  y2: 533.311197594065
})), _line179 || (_line179 = /*#__PURE__*/React.createElement("line", {
  className: "degree-tick major",
  x1: 340.09270907275703,
  y1: 535.6131886784084,
  x2: 338.5829417854984,
  y2: 526.7407255064181
})), _line180 || (_line180 = /*#__PURE__*/React.createElement("line", {
  className: "degree-tick ",
  x1: 344.19861988977175,
  y1: 534.877589394645,
  x2: 343.64382549784995,
  y2: 531.9293351344612
})), _line181 || (_line181 = /*#__PURE__*/React.createElement("line", {
  className: "degree-tick ",
  x1: 348.2910673790065,
  y1: 534.0704441218418,
  x2: 347.6849033533286,
  y2: 531.132321392279
})), _line182 || (_line182 = /*#__PURE__*/React.createElement("line", {
  className: "degree-tick ",
  x1: 352.36880494131145,
  y1: 533.1919987242677,
  x2: 351.7114559253117,
  y2: 530.2649025059715
})), _line183 || (_line183 = /*#__PURE__*/React.createElement("line", {
  className: "degree-tick ",
  x1: 356.4305904583233,
  y1: 532.2425207849006,
  x2: 355.72225668688,
  y2: 529.3273426997345
})), _line184 || (_line184 = /*#__PURE__*/React.createElement("line", {
  className: "degree-tick ",
  x1: 360.4751866708262,
  y1: 531.2222995239185,
  x2: 358.9569811477092,
  y2: 525.417555602816
})), _line185 || (_line185 = /*#__PURE__*/React.createElement("line", {
  className: "degree-tick ",
  x1: 364.5013615556328,
  y1: 530.1316457106009,
  x2: 363.691721034014,
  y2: 527.2429639652796
})), _line186 || (_line186 = /*#__PURE__*/React.createElement("line", {
  className: "degree-tick ",
  x1: 368.50788870087086,
  y1: 528.9708915686645,
  x2: 367.64795704353776,
  y2: 526.096779959016
})), _line187 || (_line187 = /*#__PURE__*/React.createElement("line", {
  className: "degree-tick ",
  x1: 372.4935476795598,
  y1: 527.7403906750653,
  x2: 371.58358683002564,
  y2: 524.8817246833281
})), _line188 || (_line188 = /*#__PURE__*/React.createElement("line", {
  className: "degree-tick ",
  x1: 376.45712442136477,
  y1: 526.4405178522959,
  x2: 375.49741156251923,
  y2: 523.5981682558236
})), _line189 || (_line189 = /*#__PURE__*/React.createElement("line", {
  className: "degree-tick major",
  x1: 380.39741158241424,
  y1: 525.0716690542101,
  x2: 377.36989399144466,
  y2: 516.5961668722524
})), _line190 || (_line190 = /*#__PURE__*/React.createElement("line", {
  className: "degree-tick ",
  x1: 384.3132089130685,
  y1: 523.6342612454122,
  x2: 383.25488411499646,
  y2: 520.8271366272689
})), _line191 || (_line191 = /*#__PURE__*/React.createElement("line", {
  className: "degree-tick ",
  x1: 388.2033236235274,
  y1: 522.1287322742452,
  x2: 387.0961689336923,
  y2: 519.3405055092965
})), _line192 || (_line192 = /*#__PURE__*/React.createElement("line", {
  className: "degree-tick ",
  x1: 392.06657074716577,
  y1: 520.5555407394181,
  x2: 390.9109234156114,
  y2: 517.7870611485467
})), _line193 || (_line193 = /*#__PURE__*/React.createElement("line", {
  className: "degree-tick ",
  x1: 395.90177350148576,
  y1: 518.9151658503123,
  x2: 394.69798554958425,
  y2: 516.1672767392205
})), _line194 || (_line194 = /*#__PURE__*/React.createElement("line", {
  className: "degree-tick ",
  x1: 399.7077636465758,
  y1: 517.2081072810097,
  x2: 397.20463987302156,
  y2: 511.75518408567046
})), _line195 || (_line195 = /*#__PURE__*/React.createElement("line", {
  className: "degree-tick ",
  x1: 403.48338184096826,
  y1: 515.434885018087,
  x2: 402.18442725719046,
  y2: 512.7306814404541
})), _line196 || (_line196 = /*#__PURE__*/React.createElement("line", {
  className: "degree-tick ",
  x1: 407.227477994786,
  y1: 513.5960392022232,
  x2: 405.8815263881569,
  y2: 510.914917371233
})), _line197 || (_line197 = /*#__PURE__*/React.createElement("line", {
  className: "degree-tick ",
  x1: 410.9389116200705,
  y1: 511.69212996366724,
  x2: 409.54637298048806,
  y2: 509.03490657500197
})), _line198 || (_line198 = /*#__PURE__*/React.createElement("line", {
  className: "degree-tick ",
  x1: 414.61655217818634,
  y1: 509.7237372516165,
  x2: 413.1778506864099,
  y2: 507.09122172126155
})), _line199 || (_line199 = /*#__PURE__*/React.createElement("line", {
  className: "degree-tick major",
  x1: 418.2592794241931,
  y1: 507.69146065755956,
  x2: 413.80600111951634,
  y2: 499.8704433106222
})), _line200 || (_line200 = /*#__PURE__*/React.createElement("line", {
  className: "degree-tick ",
  x1: 421.86598374808386,
  y1: 505.59591923263395,
  x2: 420.336285207313,
  y2: 503.01521731758
})), _line201 || (_line201 = /*#__PURE__*/React.createElement("line", {
  className: "degree-tick ",
  x1: 425.43556651278277,
  y1: 503.4377512990577,
  x2: 423.86106149379384,
  y2: 500.88413935806534
})), _line202 || (_line202 = /*#__PURE__*/React.createElement("line", {
  className: "degree-tick ",
  x1: 428.96694038880025,
  y1: 501.21761425568997,
  x2: 427.3481085010747,
  y2: 498.6918701436939
})), _line203 || (_line203 = /*#__PURE__*/React.createElement("line", {
  className: "degree-tick ",
  x1: 432.4590296854444,
  y1: 498.93618437778116,
  x2: 430.79636404085727,
  y2: 496.4390774609053
})), _line204 || (_line204 = /*#__PURE__*/React.createElement("line", {
  className: "degree-tick ",
  x1: 435.910770678487,
  y1: 496.59415661097285,
  x2: 432.4987848037133,
  y2: 491.6587384533752
})), _line205 || (_line205 = /*#__PURE__*/React.createElement("line", {
  className: "degree-tick ",
  x1: 439.32111193418376,
  y1: 494.1922443596104,
  x2: 437.57231136597227,
  y2: 491.7546848069793
})), _line206 || (_line206 = /*#__PURE__*/React.createElement("line", {
  className: "degree-tick ",
  x1: 442.6890146295514,
  y1: 491.7311792694335,
  x2: 440.89793913210934,
  y2: 489.324511747223
})), _line207 || (_line207 = /*#__PURE__*/React.createElement("line", {
  className: "degree-tick ",
  x1: 446.0134528688034,
  y1: 489.2117110047095,
  x2: 444.18064802107784,
  y2: 486.8366686071609
})), _line208 || (_line208 = /*#__PURE__*/React.createElement("line", {
  className: "degree-tick ",
  x1: 449.29341399584746,
  y1: 486.63460701987856,
  x2: 447.4194380879498,
  y2: 484.2919132079135
})), _line209 || (_line209 = /*#__PURE__*/React.createElement("line", {
  className: "degree-tick major",
  x1: 452.5278989027506,
  y1: 484.00065232577924,
  x2: 446.7841704921868,
  y2: 477.0717574683231
})), _line210 || (_line210 = /*#__PURE__*/React.createElement("line", {
  className: "degree-tick ",
  x1: 455.71592233407705,
  y1: 481.31064925052715,
  x2: 453.7613291667037,
  y2: 479.0347833603531
})), _line211 || (_line211 = /*#__PURE__*/React.createElement("line", {
  className: "degree-tick ",
  x1: 458.8565131870065,
  y1: 478.5654171951177,
  x2: 456.86249837712774,
  y2: 476.3240102847187
})), _line212 || (_line212 = /*#__PURE__*/React.createElement("line", {
  className: "degree-tick ",
  x1: 461.94871480714164,
  y1: 475.7657923838285,
  x2: 459.91588575098507,
  y2: 473.55952720746245
})), _line213 || (_line213 = /*#__PURE__*/React.createElement("line", {
  className: "degree-tick ",
  x1: 464.99158527991403,
  y1: 472.9126276094978,
  x2: 462.92056119690255,
  y2: 470.7421762169099
})), _line214 || (_line214 = /*#__PURE__*/React.createElement("line", {
  className: "degree-tick ",
  x1: 467.9841977175008,
  y1: 470.00679197375496,
  x2: 463.7670212057644,
  y2: 465.7388390371753
})), _line215 || (_line215 = /*#__PURE__*/React.createElement("line", {
  className: "degree-tick ",
  x1: 470.92564054116343,
  y1: 467.0491706222841,
  x2: 468.7801304088475,
  y2: 464.9523191081969
})), _line216 || (_line216 = /*#__PURE__*/React.createElement("line", {
  className: "degree-tick ",
  x1: 473.8150177589233,
  y1: 464.0406644752001,
  x2: 471.6332392933301,
  y2: 461.98157663659924
})), _line217 || (_line217 = /*#__PURE__*/React.createElement("line", {
  className: "degree-tick ",
  x1: 476.65144923848993,
  y1: 460.98218995261936,
  x2: 474.4340670304754,
  y2: 458.9614930076074
})), _line218 || (_line218 = /*#__PURE__*/React.createElement("line", {
  className: "degree-tick ",
  x1: 479.4340709753575,
  y1: 457.8746786955096,
  x2: 477.18176046102246,
  y2: 455.8929881679509
})), _line219 || (_line219 = /*#__PURE__*/React.createElement("line", {
  className: "degree-tick major",
  x1: 482.162035355989,
  y1: 454.71907728190274,
  x2: 475.3023771208263,
  y2: 448.8928358779817
})), _line220 || (_line220 = /*#__PURE__*/React.createElement("line", {
  className: "degree-tick ",
  x1: 484.83451141600796,
  y1: 451.5163469385585,
  x2: 482.51441294635094,
  y2: 449.6144681066937
})), _line221 || (_line221 = /*#__PURE__*/React.createElement("line", {
  className: "degree-tick ",
  x1: 487.4506850933174,
  y1: 448.267463248165,
  x2: 485.09774762352686,
  y2: 446.4063653831252
})), _line222 || (_line222 = /*#__PURE__*/React.createElement("line", {
  className: "degree-tick ",
  x1: 490.0097594760719,
  y1: 444.97341585216685,
  x2: 487.62469973369446,
  y2: 443.1536658623907
})), _line223 || (_line223 = /*#__PURE__*/React.createElement("line", {
  className: "degree-tick ",
  x1: 492.5109550454241,
  y1: 441.6352081493112,
  x2: 490.09449954276187,
  y2: 439.8573603482738
})), _line224 || (_line224 = /*#__PURE__*/React.createElement("line", {
  className: "degree-tick ",
  x1: 494.95350991297397,
  y1: 438.2538569900022,
  x2: 490.0592795385897,
  y2: 434.7830488647302
})), _line225 || (_line225 = /*#__PURE__*/React.createElement("line", {
  className: "degree-tick ",
  x1: 497.33668005284727,
  y1: 434.8303923665587,
  x2: 494.859650596117,
  y2: 433.1379606632129
})), _line226 || (_line226 = /*#__PURE__*/React.createElement("line", {
  className: "degree-tick ",
  x1: 499.65973952833315,
  y1: 431.36585709946917,
  x2: 497.15355032923276,
  y2: 429.71691328650513
})), _line227 || (_line227 = /*#__PURE__*/React.createElement("line", {
  className: "degree-tick ",
  x1: 501.92198071301135,
  y1: 427.8613065197375,
  x2: 499.3873951810489,
  y2: 426.25635288141444
})), _line228 || (_line228 = /*#__PURE__*/React.createElement("line", {
  className: "degree-tick ",
  x1: 504.12271450630226,
  y1: 424.3178081474196,
  x2: 501.5605047007838,
  y2: 422.7573335681633
})), _line229 || (_line229 = /*#__PURE__*/React.createElement("line", {
  className: "degree-tick major",
  x1: 506.26127054337337,
  y1: 420.73644136644634,
  x2: 498.4941097279325,
  y2: 416.1898808128982
})), _line230 || (_line230 = /*#__PURE__*/React.createElement("line", {
  className: "degree-tick ",
  x1: 508.3369973993392,
  y1: 417.1182970958327,
  x2: 505.7218886453726,
  y2: 415.6481929481863
})), _line231 || (_line231 = /*#__PURE__*/React.createElement("line", {
  className: "degree-tick ",
  x1: 510.3492627876914,
  y1: 413.4644774573733,
  x2: 507.7088954723647,
  y2: 412.04023715456105
})), _line232 || (_line232 = /*#__PURE__*/React.createElement("line", {
  className: "degree-tick ",
  x1: 512.2974537528993,
  y1: 409.77609543992526,
  x2: 509.63263215767466,
  y2: 408.3981528193404
})), _line233 || (_line233 = /*#__PURE__*/React.createElement("line", {
  className: "degree-tick ",
  x1: 514.1809768571226,
  y1: 406.05427456038126,
  x2: 511.4925127124725,
  y2: 404.72304935669445
})), _line234 || (_line234 = /*#__PURE__*/React.createElement("line", {
  className: "degree-tick ",
  x1: 515.9992583609774,
  y1: 402.3001485214354,
  x2: 510.5766828372708,
  y2: 399.7319439560437
})), _line235 || (_line235 = /*#__PURE__*/React.createElement("line", {
  className: "degree-tick ",
  x1: 517.7517443983037,
  y1: 398.5148608662461,
  x2: 515.0184589037642,
  y2: 397.2782726545359
})), _line236 || (_line236 = /*#__PURE__*/React.createElement("line", {
  className: "degree-tick ",
  x1: 519.4379011448777,
  y1: 394.69956463010203,
  x2: 516.6834505028918,
  y2: 393.5108671661259
})), _line237 || (_line237 = /*#__PURE__*/React.createElement("line", {
  className: "degree-tick ",
  x1: 521.0572149810204,
  y1: 390.85542198919643,
  x2: 518.2824382239364,
  y2: 389.71497736171693
})), _line238 || (_line238 = /*#__PURE__*/React.createElement("line", {
  className: "degree-tick ",
  x1: 522.6091926480505,
  y1: 386.9836039066166,
  x2: 519.8149349997485,
  y2: 385.89175950611514
})), _line239 || (_line239 = /*#__PURE__*/React.createElement("line", {
  className: "degree-tick major",
  x1: 524.0933613985362,
  y1: 383.08528977565777,
  x2: 515.6546992538215,
  y2: 379.9565550142313
})), _line240 || (_line240 = /*#__PURE__*/React.createElement("line", {
  className: "degree-tick ",
  x1: 525.509269140299,
  y1: 379.161667060568,
  x2: 522.6786088582031,
  y2: 378.1680059677575
})), _line241 || (_line241 = /*#__PURE__*/React.createElement("line", {
  className: "degree-tick ",
  x1: 526.8564845741241,
  y1: 375.2139309348353,
  x2: 524.0089136380473,
  y2: 374.26982301515113
})), _line242 || (_line242 = /*#__PURE__*/React.createElement("line", {
  className: "degree-tick ",
  x1: 528.13459732514,
  y1: 371.24328391712606,
  x2: 525.2709831327742,
  y2: 370.34901675498645
})), _line243 || (_line243 = /*#__PURE__*/React.createElement("line", {
  className: "degree-tick ",
  x1: 529.3432180678211,
  y1: 367.25093550498656,
  x2: 526.4644329037899,
  y2: 366.4067815028319
})), _line244 || (_line244 = /*#__PURE__*/React.createElement("line", {
  className: "degree-tick ",
  x1: 530.4819786445811,
  y1: 363.2381018064178,
  x2: 524.6958201848845,
  y2: 361.6505343970516
})), _line245 || (_line245 = /*#__PURE__*/React.createElement("line", {
  className: "degree-tick ",
  x1: 531.5505321779169,
  y1: 359.2060051694375,
  x2: 528.6440401422109,
  y2: 358.462833556432
})), _line246 || (_line246 = /*#__PURE__*/React.createElement("line", {
  className: "degree-tick ",
  x1: 532.548553176071,
  y1: 355.15587380974114,
  x2: 529.629533680137,
  y2: 354.46354066568585
})), _line247 || (_line247 = /*#__PURE__*/React.createElement("line", {
  className: "degree-tick ",
  x1: 533.4757376321792,
  y1: 351.08894143657545,
  x2: 530.545079837633,
  y2: 350.44765765285274
})), _line248 || (_line248 = /*#__PURE__*/React.createElement("line", {
  className: "degree-tick ",
  x1: 534.3318031168743,
  y1: 347.00644687693847,
  x2: 531.3903997304701,
  y2: 346.41640779480116
})), _line249 || (_line249 = /*#__PURE__*/React.createElement("line", {
  className: "degree-tick major",
  x1: 535.116488864317,
  y1: 342.90963369822106,
  x2: 526.2627298694264,
  y2: 341.2937897514261
})), _line250 || (_line250 = /*#__PURE__*/React.createElement("line", {
  className: "degree-tick ",
  x1: 535.829555851627,
  y1: 338.7997498294042,
  x2: 532.8693522216902,
  y2: 338.312723680918
})), _line251 || (_line251 = /*#__PURE__*/React.createElement("line", {
  className: "degree-tick ",
  x1: 536.4707868716923,
  y1: 334.67804718092776,
  x2: 533.5025343168176,
  y2: 334.24275788576966
})), _line252 || (_line252 = /*#__PURE__*/React.createElement("line", {
  className: "degree-tick ",
  x1: 537.0399865993327,
  y1: 330.5457812633462,
  x2: 534.0645892780021,
  y2: 330.1623614148523
})), _line253 || (_line253 = /*#__PURE__*/React.createElement("line", {
  className: "degree-tick ",
  x1: 537.5369816507969,
  y1: 326.4042108048882,
  x2: 534.555345897858,
  y2: 326.0727771964586
})), _line254 || (_line254 = /*#__PURE__*/React.createElement("line", {
  className: "degree-tick ",
  x1: 537.9616206365779,
  y1: 322.25459736803566,
  x2: 531.9876887377517,
  y2: 321.6959045470808
})), _line255 || (_line255 = /*#__PURE__*/React.createElement("line", {
  className: "degree-tick ",
  x1: 538.313774207527,
  y1: 318.09820496523974,
  x2: 535.3223879204032,
  y2: 317.87103084433716
})), _line256 || (_line256 = /*#__PURE__*/React.createElement("line", {
  className: "degree-tick ",
  x1: 538.5933350942552,
  y1: 313.9362996738901,
  x2: 535.598439674662,
  y2: 313.7613670420003
})), _line257 || (_line257 = /*#__PURE__*/React.createElement("line", {
  className: "degree-tick ",
  x1: 538.8002181398081,
  y1: 309.7701492506559,
  x2: 535.8027258619024,
  y2: 309.6475113939531
})), _line258 || (_line258 = /*#__PURE__*/React.createElement("line", {
  className: "degree-tick ",
  x1: 538.9343603256059,
  y1: 305.6010227453143,
  x2: 535.9351842545732,
  y2: 305.53071702047777
})), _line259 || (_line259 = /*#__PURE__*/React.createElement("line", {
  className: "degree-tick major",
  x1: 538.9957207906394,
  y1: 301.43019011418625,
  x2: 529.9958819324145,
  y2: 301.3763335826897
})), _line260 || (_line260 = /*#__PURE__*/React.createElement("line", {
  className: "degree-tick ",
  x1: 538.9842808439166,
  y1: 297.2589218332948,
  x2: 535.9844781554992,
  y2: 297.2933286722074
})), _line261 || (_line261 = /*#__PURE__*/React.createElement("line", {
  className: "degree-tick ",
  x1: 538.900043970156,
  y1: 293.08848851136634,
  x2: 535.9012986483549,
  y2: 293.17524388570064
})), _line262 || (_line262 = /*#__PURE__*/React.createElement("line", {
  className: "degree-tick ",
  x1: 538.7430358287254,
  y1: 288.9201605027907,
  x2: 535.7462613204151,
  y2: 289.05923798601924
})), _line263 || (_line263 = /*#__PURE__*/React.createElement("line", {
  className: "degree-tick ",
  x1: 538.5133042458257,
  y1: 284.75520752065864,
  x2: 535.5194133975517,
  y2: 284.9465647484328
})), _line264 || (_line264 = /*#__PURE__*/React.createElement("line", {
  className: "degree-tick ",
  x1: 538.2109191999224,
  y1: 280.5948982499954,
  x2: 532.230728759757,
  y2: 281.08205561610436
})), _line265 || (_line265 = /*#__PURE__*/React.createElement("line", {
  className: "degree-tick ",
  x1: 537.8359728004299,
  y1: 276.4404999613067,
  x2: 534.8505840205082,
  y2: 276.73622590321503
})), _line266 || (_line266 = /*#__PURE__*/React.createElement("line", {
  className: "degree-tick ",
  x1: 537.3885792596535,
  y1: 272.29327812455585,
  x2: 534.4088062982353,
  y2: 272.6410612443313
})), _line267 || (_line267 = /*#__PURE__*/React.createElement("line", {
  className: "degree-tick ",
  x1: 536.8688748579998,
  y1: 268.1544960236892,
  x2: 533.8956253827948,
  y2: 268.5542303832245
})), _line268 || (_line268 = /*#__PURE__*/React.createElement("line", {
  className: "degree-tick ",
  x1: 536.2770179024641,
  y1: 264.0254143718281,
  x2: 533.311197594065,
  y2: 264.476978208165
})), _line269 || (_line269 = /*#__PURE__*/React.createElement("line", {
  className: "degree-tick major",
  x1: 535.6131886784084,
  y1: 259.90729092724297,
  x2: 526.7407255064181,
  y2: 261.4170582145016
})), _line270 || (_line270 = /*#__PURE__*/React.createElement("line", {
  className: "degree-tick ",
  x1: 534.877589394645,
  y1: 255.80138011022822,
  x2: 531.9293351344612,
  y2: 256.35617450215005
})), _line271 || (_line271 = /*#__PURE__*/React.createElement("line", {
  className: "degree-tick ",
  x1: 534.0704441218418,
  y1: 251.7089326209935,
  x2: 531.132321392279,
  y2: 252.3150966466714
})), _line272 || (_line272 = /*#__PURE__*/React.createElement("line", {
  className: "degree-tick ",
  x1: 533.1919987242677,
  y1: 247.63119505868855,
  x2: 530.2649025059715,
  y2: 248.28854407468828
})), _line273 || (_line273 = /*#__PURE__*/React.createElement("line", {
  className: "degree-tick ",
  x1: 532.2425207849006,
  y1: 243.56940954167666,
  x2: 529.3273426997345,
  y2: 244.27774331312006
})), _line274 || (_line274 = /*#__PURE__*/React.createElement("line", {
  className: "degree-tick ",
  x1: 531.2222995239185,
  y1: 239.5248133291738,
  x2: 525.417555602816,
  y2: 241.0430188522908
})), _line275 || (_line275 = /*#__PURE__*/React.createElement("line", {
  className: "degree-tick ",
  x1: 530.1316457106009,
  y1: 235.4986384443672,
  x2: 527.2429639652796,
  y2: 236.30827896598603
})), _line276 || (_line276 = /*#__PURE__*/React.createElement("line", {
  className: "degree-tick ",
  x1: 528.9708915686645,
  y1: 231.49211129912914,
  x2: 526.096779959016,
  y2: 232.35204295646224
})), _line277 || (_line277 = /*#__PURE__*/React.createElement("line", {
  className: "degree-tick ",
  x1: 527.7403906750653,
  y1: 227.5064523204402,
  x2: 524.8817246833281,
  y2: 228.41641316997442
})), _line278 || (_line278 = /*#__PURE__*/React.createElement("line", {
  className: "degree-tick ",
  x1: 526.4405178522959,
  y1: 223.5428755786352,
  x2: 523.5981682558236,
  y2: 224.50258843748077
})), _line279 || (_line279 = /*#__PURE__*/React.createElement("line", {
  className: "degree-tick major",
  x1: 525.0716690542101,
  y1: 219.60258841758576,
  x2: 516.5961668722524,
  y2: 222.63010600855534
})), _line280 || (_line280 = /*#__PURE__*/React.createElement("line", {
  className: "degree-tick ",
  x1: 523.6342612454122,
  y1: 215.68679108693152,
  x2: 520.8271366272689,
  y2: 216.74511588500351
})), _line281 || (_line281 = /*#__PURE__*/React.createElement("line", {
  className: "degree-tick ",
  x1: 522.1287322742452,
  y1: 211.7966763764726,
  x2: 519.3405055092965,
  y2: 212.90383106630767
})), _line282 || (_line282 = /*#__PURE__*/React.createElement("line", {
  className: "degree-tick ",
  x1: 520.5555407394181,
  y1: 207.9334292528342,
  x2: 517.7870611485467,
  y2: 209.08907658438858
})), _line283 || (_line283 = /*#__PURE__*/React.createElement("line", {
  className: "degree-tick ",
  x1: 518.9151658503123,
  y1: 204.0982264985143,
  x2: 516.1672767392205,
  y2: 205.30201445041578
})), _line284 || (_line284 = /*#__PURE__*/React.createElement("line", {
  className: "degree-tick ",
  x1: 517.2081072810097,
  y1: 200.29223635342424,
  x2: 511.75518408567046,
  y2: 202.79536012697844
})), _line285 || (_line285 = /*#__PURE__*/React.createElement("line", {
  className: "degree-tick ",
  x1: 515.434885018087,
  y1: 196.51661815903174,
  x2: 512.7306814404541,
  y2: 197.8155727428096
})), _line286 || (_line286 = /*#__PURE__*/React.createElement("line", {
  className: "degree-tick ",
  x1: 513.5960392022232,
  y1: 192.77252200521406,
  x2: 510.914917371233,
  y2: 194.11847361184317
})), _line287 || (_line287 = /*#__PURE__*/React.createElement("line", {
  className: "degree-tick ",
  x1: 511.6921299636672,
  y1: 189.06108837992946,
  x2: 509.03490657500197,
  y2: 190.45362701951194
})), _line288 || (_line288 = /*#__PURE__*/React.createElement("line", {
  className: "degree-tick ",
  x1: 509.72373725161657,
  y1: 185.38344782181372,
  x2: 507.09122172126155,
  y2: 186.8221493135901
})), _line289 || (_line289 = /*#__PURE__*/React.createElement("line", {
  className: "degree-tick major",
  x1: 507.69146065755956,
  y1: 181.7407205758069,
  x2: 499.8704433106222,
  y2: 186.19399888048366
})), _line290 || (_line290 = /*#__PURE__*/React.createElement("line", {
  className: "degree-tick ",
  x1: 505.59591923263395,
  y1: 178.13401625191608,
  x2: 503.01521731758,
  y2: 179.66371479268702
})), _line291 || (_line291 = /*#__PURE__*/React.createElement("line", {
  className: "degree-tick ",
  x1: 503.4377512990577,
  y1: 174.56443348721723,
  x2: 500.88413935806534,
  y2: 176.13893850620616
})), _line292 || (_line292 = /*#__PURE__*/React.createElement("line", {
  className: "degree-tick ",
  x1: 501.21761425568997,
  y1: 171.03305961119977,
  x2: 498.6918701436939,
  y2: 172.6518914989253
})), _line293 || (_line293 = /*#__PURE__*/React.createElement("line", {
  className: "degree-tick ",
  x1: 498.93618437778116,
  y1: 167.54097031455558,
  x2: 496.4390774609053,
  y2: 169.20363595914276
})), _line294 || (_line294 = /*#__PURE__*/React.createElement("line", {
  className: "degree-tick ",
  x1: 496.59415661097285,
  y1: 164.089229321513,
  x2: 491.6587384533752,
  y2: 167.50121519628672
})), _line295 || (_line295 = /*#__PURE__*/React.createElement("line", {
  className: "degree-tick ",
  x1: 494.1922443596104,
  y1: 160.67888806581627,
  x2: 491.7546848069793,
  y2: 162.42768863402776
})), _line296 || (_line296 = /*#__PURE__*/React.createElement("line", {
  className: "degree-tick ",
  x1: 491.73117926943354,
  y1: 157.31098537044858,
  x2: 489.3245117472231,
  y2: 159.10206086789066
})), _line297 || (_line297 = /*#__PURE__*/React.createElement("line", {
  className: "degree-tick ",
  x1: 489.2117110047095,
  y1: 153.9865471311966,
  x2: 486.8366686071609,
  y2: 155.81935197892216
})), _line298 || (_line298 = /*#__PURE__*/React.createElement("line", {
  className: "degree-tick ",
  x1: 486.63460701987856,
  y1: 150.70658600415254,
  x2: 484.2919132079136,
  y2: 152.5805619120502
})), _line299 || (_line299 = /*#__PURE__*/React.createElement("line", {
  className: "degree-tick major",
  x1: 484.00065232577924,
  y1: 147.4721010972494,
  x2: 477.0717574683231,
  y2: 153.21582950781323
})), _line300 || (_line300 = /*#__PURE__*/React.createElement("line", {
  className: "degree-tick ",
  x1: 481.31064925052715,
  y1: 144.28407766592295,
  x2: 479.0347833603532,
  y2: 146.2386708332963
})), _line301 || (_line301 = /*#__PURE__*/React.createElement("line", {
  className: "degree-tick ",
  x1: 478.5654171951177,
  y1: 141.1434868129935,
  x2: 476.3240102847187,
  y2: 143.13750162287226
})), _line302 || (_line302 = /*#__PURE__*/React.createElement("line", {
  className: "degree-tick ",
  x1: 475.7657923838285,
  y1: 138.0512851928584,
  x2: 473.55952720746245,
  y2: 140.08411424901496
})), _line303 || (_line303 = /*#__PURE__*/React.createElement("line", {
  className: "degree-tick ",
  x1: 472.9126276094978,
  y1: 135.00841472008597,
  x2: 470.7421762169099,
  y2: 137.07943880309745
})), _line304 || (_line304 = /*#__PURE__*/React.createElement("line", {
  className: "degree-tick ",
  x1: 470.00679197375496,
  y1: 132.01580228249915,
  x2: 465.73883903717535,
  y2: 136.23297879423558
})), _line305 || (_line305 = /*#__PURE__*/React.createElement("line", {
  className: "degree-tick ",
  x1: 467.0491706222841,
  y1: 129.0743594588366,
  x2: 464.9523191081969,
  y2: 131.21986959115247
})), _line306 || (_line306 = /*#__PURE__*/React.createElement("line", {
  className: "degree-tick ",
  x1: 464.0406644752002,
  y1: 126.18498224107674,
  x2: 461.9815766365993,
  y2: 128.3667607066699
})), _line307 || (_line307 = /*#__PURE__*/React.createElement("line", {
  className: "degree-tick ",
  x1: 460.98218995261936,
  y1: 123.3485507615101,
  x2: 458.96149300760743,
  y2: 125.5659329695246
})), _line308 || (_line308 = /*#__PURE__*/React.createElement("line", {
  className: "degree-tick ",
  x1: 457.8746786955096,
  y1: 120.56592902464254,
  x2: 455.8929881679509,
  y2: 122.8182395389776
})), _line309 || (_line309 = /*#__PURE__*/React.createElement("line", {
  className: "degree-tick major",
  x1: 454.71907728190274,
  y1: 117.83796464401095,
  x2: 448.8928358779817,
  y2: 124.69762287917371
})), _line310 || (_line310 = /*#__PURE__*/React.createElement("line", {
  className: "degree-tick ",
  x1: 451.5163469385585,
  y1: 115.16548858399204,
  x2: 449.6144681066937,
  y2: 117.48558705364906
})), _line311 || (_line311 = /*#__PURE__*/React.createElement("line", {
  className: "degree-tick ",
  x1: 448.267463248165,
  y1: 112.54931490668261,
  x2: 446.40636538312526,
  y2: 114.9022523764732
})), _line312 || (_line312 = /*#__PURE__*/React.createElement("line", {
  className: "degree-tick ",
  x1: 444.97341585216685,
  y1: 109.9902405239281,
  x2: 443.1536658623907,
  y2: 112.37530026630557
})), _line313 || (_line313 = /*#__PURE__*/React.createElement("line", {
  className: "degree-tick ",
  x1: 441.6352081493112,
  y1: 107.48904495457592,
  x2: 439.8573603482738,
  y2: 109.90550045723816
})), _line314 || (_line314 = /*#__PURE__*/React.createElement("line", {
  className: "degree-tick ",
  x1: 438.2538569900022,
  y1: 105.04649008702606,
  x2: 434.7830488647302,
  y2: 109.94072046141034
})), _line315 || (_line315 = /*#__PURE__*/React.createElement("line", {
  className: "degree-tick ",
  x1: 434.8303923665587,
  y1: 102.66331994715276,
  x2: 433.1379606632129,
  y2: 105.14034940388305
})), _line316 || (_line316 = /*#__PURE__*/React.createElement("line", {
  className: "degree-tick ",
  x1: 431.3658570994692,
  y1: 100.34026047166688,
  x2: 429.7169132865052,
  y2: 102.8464496707673
})), _line317 || (_line317 = /*#__PURE__*/React.createElement("line", {
  className: "degree-tick ",
  x1: 427.8613065197375,
  y1: 98.07801928698865,
  x2: 426.2563528814145,
  y2: 100.61260481895113
})), _line318 || (_line318 = /*#__PURE__*/React.createElement("line", {
  className: "degree-tick ",
  x1: 424.3178081474196,
  y1: 95.87728549369777,
  x2: 422.7573335681633,
  y2: 98.43949529921619
})), _line319 || (_line319 = /*#__PURE__*/React.createElement("line", {
  className: "degree-tick major",
  x1: 420.73644136644634,
  y1: 93.73872945662663,
  x2: 416.1898808128982,
  y2: 101.50589027206749
})), _line320 || (_line320 = /*#__PURE__*/React.createElement("line", {
  className: "degree-tick ",
  x1: 417.11829709583276,
  y1: 91.66300260066083,
  x2: 415.6481929481863,
  y2: 94.27811135462744
})), _line321 || (_line321 = /*#__PURE__*/React.createElement("line", {
  className: "degree-tick ",
  x1: 413.4644774573733,
  y1: 89.65073721230863,
  x2: 412.04023715456105,
  y2: 92.2911045276353
})), _line322 || (_line322 = /*#__PURE__*/React.createElement("line", {
  className: "degree-tick ",
  x1: 409.77609543992526,
  y1: 87.70254624710068,
  x2: 408.39815281934045,
  y2: 90.36736784232536
})), _line323 || (_line323 = /*#__PURE__*/React.createElement("line", {
  className: "degree-tick ",
  x1: 406.05427456038126,
  y1: 85.81902314287746,
  x2: 404.72304935669445,
  y2: 88.50748728752751
})), _line324 || (_line324 = /*#__PURE__*/React.createElement("line", {
  className: "degree-tick ",
  x1: 402.3001485214354,
  y1: 84.00074163902264,
  x2: 399.7319439560438,
  y2: 89.42331716272918
})), _line325 || (_line325 = /*#__PURE__*/React.createElement("line", {
  className: "degree-tick ",
  x1: 398.5148608662461,
  y1: 82.24825560169634,
  x2: 397.27827265453595,
  y2: 84.98154109623573
})), _line326 || (_line326 = /*#__PURE__*/React.createElement("line", {
  className: "degree-tick ",
  x1: 394.6995646301021,
  y1: 80.56209885512231,
  x2: 393.5108671661259,
  y2: 83.31654949710821
})), _line327 || (_line327 = /*#__PURE__*/React.createElement("line", {
  className: "degree-tick ",
  x1: 390.85542198919643,
  y1: 78.94278501897966,
  x2: 389.714977361717,
  y2: 81.7175617760636
})), _line328 || (_line328 = /*#__PURE__*/React.createElement("line", {
  className: "degree-tick ",
  x1: 386.9836039066166,
  y1: 77.39080735194958,
  x2: 385.89175950611514,
  y2: 80.18506500025146
})), _line329 || (_line329 = /*#__PURE__*/React.createElement("line", {
  className: "degree-tick major",
  x1: 383.08528977565777,
  y1: 75.90663860146375,
  x2: 379.9565550142313,
  y2: 84.34530074617851
})), _line330 || (_line330 = /*#__PURE__*/React.createElement("line", {
  className: "degree-tick ",
  x1: 379.161667060568,
  y1: 74.49073085970105,
  x2: 378.1680059677575,
  y2: 77.32139114179685
})), _line331 || (_line331 = /*#__PURE__*/React.createElement("line", {
  className: "degree-tick ",
  x1: 375.2139309348353,
  y1: 73.14351542587585,
  x2: 374.26982301515113,
  y2: 75.99108636195271
})), _line332 || (_line332 = /*#__PURE__*/React.createElement("line", {
  className: "degree-tick ",
  x1: 371.2432839171261,
  y1: 71.86540267486004,
  x2: 370.34901675498645,
  y2: 74.7290168672258
})), _line333 || (_line333 = /*#__PURE__*/React.createElement("line", {
  className: "degree-tick ",
  x1: 367.2509355049866,
  y1: 70.65678193217892,
  x2: 366.40678150283196,
  y2: 73.53556709621014
})), _line334 || (_line334 = /*#__PURE__*/React.createElement("line", {
  className: "degree-tick ",
  x1: 363.2381018064178,
  y1: 69.51802135541891,
  x2: 361.6505343970517,
  y2: 75.3041798151155
})), _line335 || (_line335 = /*#__PURE__*/React.createElement("line", {
  className: "degree-tick ",
  x1: 359.2060051694375,
  y1: 68.44946782208311,
  x2: 358.46283355643203,
  y2: 71.35595985778917
})), _line336 || (_line336 = /*#__PURE__*/React.createElement("line", {
  className: "degree-tick ",
  x1: 355.1558738097412,
  y1: 67.45144682392905,
  x2: 354.46354066568585,
  y2: 70.37046631986297
})), _line337 || (_line337 = /*#__PURE__*/React.createElement("line", {
  className: "degree-tick ",
  x1: 351.08894143657545,
  y1: 66.52426236782082,
  x2: 350.44765765285274,
  y2: 69.45492016236702
})), _line338 || (_line338 = /*#__PURE__*/React.createElement("line", {
  className: "degree-tick ",
  x1: 347.00644687693847,
  y1: 65.66819688312566,
  x2: 346.41640779480116,
  y2: 68.60960026952995
})), _line339 || (_line339 = /*#__PURE__*/React.createElement("line", {
  className: "degree-tick major",
  x1: 342.90963369822106,
  y1: 64.88351113568302,
  x2: 341.2937897514261,
  y2: 73.73727013057362
})), _line340 || (_line340 = /*#__PURE__*/React.createElement("line", {
  className: "degree-tick ",
  x1: 338.7997498294042,
  y1: 64.17044414837304,
  x2: 338.312723680918,
  y2: 67.13064777830976
})), _line341 || (_line341 = /*#__PURE__*/React.createElement("line", {
  className: "degree-tick ",
  x1: 334.6780471809278,
  y1: 63.529213128307674,
  x2: 334.2427578857697,
  y2: 66.49746568318247
})), _line342 || (_line342 = /*#__PURE__*/React.createElement("line", {
  className: "degree-tick ",
  x1: 330.5457812633462,
  y1: 62.96001340066735,
  x2: 330.16236141485234,
  y2: 65.93541072199787
})), _line343 || (_line343 = /*#__PURE__*/React.createElement("line", {
  className: "degree-tick ",
  x1: 326.4042108048882,
  y1: 62.46301834920311,
  x2: 326.0727771964586,
  y2: 65.44465410214198
})), _line344 || (_line344 = /*#__PURE__*/React.createElement("line", {
  className: "degree-tick ",
  x1: 322.2545973680357,
  y1: 62.03837936342211,
  x2: 321.69590454708083,
  y2: 68.01231126224832
})), _line345 || (_line345 = /*#__PURE__*/React.createElement("line", {
  className: "degree-tick ",
  x1: 318.09820496523974,
  y1: 61.68622579247298,
  x2: 317.87103084433716,
  y2: 64.67761207959674
})), _line346 || (_line346 = /*#__PURE__*/React.createElement("line", {
  className: "degree-tick ",
  x1: 313.9362996738901,
  y1: 61.40666490574483,
  x2: 313.7613670420003,
  y2: 64.40156032533798
})), _line347 || (_line347 = /*#__PURE__*/React.createElement("line", {
  className: "degree-tick ",
  x1: 309.77014925065595,
  y1: 61.19978186019196,
  x2: 309.64751139395315,
  y2: 64.1972741380975
})), _line348 || (_line348 = /*#__PURE__*/React.createElement("line", {
  className: "degree-tick ",
  x1: 305.6010227453143,
  y1: 61.065639674394106,
  x2: 305.53071702047777,
  y2: 64.06481574542681
})), _line349 || (_line349 = /*#__PURE__*/React.createElement("line", {
  className: "degree-tick major",
  x1: 301.43019011418625,
  y1: 61.00427920936056,
  x2: 301.37633358268965,
  y2: 70.00411806758547
})), _line350 || (_line350 = /*#__PURE__*/React.createElement("line", {
  className: "degree-tick ",
  x1: 297.2589218332948,
  y1: 61.01571915608338,
  x2: 297.2933286722074,
  y2: 64.01552184450074
})), _line351 || (_line351 = /*#__PURE__*/React.createElement("line", {
  className: "degree-tick ",
  x1: 293.0884885113664,
  y1: 61.09995602984395,
  x2: 293.1752438857007,
  y2: 64.09870135164508
})), _line352 || (_line352 = /*#__PURE__*/React.createElement("line", {
  className: "degree-tick ",
  x1: 288.9201605027907,
  y1: 61.25696417127455,
  x2: 289.05923798601924,
  y2: 64.25373867958493
})), _line353 || (_line353 = /*#__PURE__*/React.createElement("line", {
  className: "degree-tick ",
  x1: 284.75520752065864,
  y1: 61.48669575417432,
  x2: 284.9465647484328,
  y2: 64.48058660244826
})), _line354 || (_line354 = /*#__PURE__*/React.createElement("line", {
  className: "degree-tick ",
  x1: 280.5948982499954,
  y1: 61.789080800077585,
  x2: 281.0820556161043,
  y2: 67.769271240243
})), _line355 || (_line355 = /*#__PURE__*/React.createElement("line", {
  className: "degree-tick ",
  x1: 276.4404999613068,
  y1: 62.16402719957014,
  x2: 276.73622590321503,
  y2: 65.14941597949183
})), _line356 || (_line356 = /*#__PURE__*/React.createElement("line", {
  className: "degree-tick ",
  x1: 272.29327812455585,
  y1: 62.61142074034652,
  x2: 272.6410612443313,
  y2: 65.59119370176475
})), _line357 || (_line357 = /*#__PURE__*/React.createElement("line", {
  className: "degree-tick ",
  x1: 268.15449602368926,
  y1: 63.1311251420002,
  x2: 268.55423038322454,
  y2: 66.10437461720522
})), _line358 || (_line358 = /*#__PURE__*/React.createElement("line", {
  className: "degree-tick ",
  x1: 264.02541437182816,
  y1: 63.72298209753592,
  x2: 264.47697820816506,
  y2: 66.68880240593504
})), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
  className: "house-sector "
}, /*#__PURE__*/React.createElement("path", {
  className: "house-hit",
  d: "M 72 300 A 228 228 0 0 0 83.51563603877727 371.5438338384577 L 300 300 Z"
}), /*#__PURE__*/React.createElement("line", {
  className: "house-ray",
  x1: 300,
  y1: 300,
  x2: 72,
  y2: 300,
  pointerEvents: "none",
  "data-cusp": 80.34286337450281
}), /*#__PURE__*/React.createElement("text", {
  className: "house-number",
  x: 197.32158360050394,
  y: 316.5270325736866,
  textAnchor: "middle",
  dominantBaseline: "central",
  pointerEvents: "none"
}, "I"))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
  className: "house-sector "
}, /*#__PURE__*/React.createElement("path", {
  className: "house-hit",
  d: "M 83.51563603877727 371.5438338384577 A 228 228 0 0 0 114.77737333696584 432.95329470173454 L 300 300 Z"
}), /*#__PURE__*/React.createElement("line", {
  className: "house-ray",
  x1: 300,
  y1: 300,
  x2: 83.51563603877727,
  y2: 371.5438338384577,
  pointerEvents: "none",
  "data-cusp": 98.63057028740255
}), /*#__PURE__*/React.createElement("text", {
  className: "house-number",
  x: 207.31826655865726,
  y: 347.1815248408515,
  textAnchor: "middle",
  dominantBaseline: "central",
  pointerEvents: "none"
}, "II"))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
  className: "house-sector "
}, /*#__PURE__*/React.createElement("path", {
  className: "house-hit",
  d: "M 114.77737333696584 432.95329470173454 A 228 228 0 0 0 173.0506483323189 489.38812558118696 L 300 300 Z"
}), /*#__PURE__*/React.createElement("line", {
  className: "house-ray",
  x1: 300,
  y1: 300,
  x2: 114.77737333696584,
  y2: 432.95329470173454,
  pointerEvents: "none",
  "data-cusp": 116.0137492113849
}), /*#__PURE__*/React.createElement("text", {
  className: "house-number",
  x: 227.6488089020828,
  y: 374.70813306938317,
  textAnchor: "middle",
  dominantBaseline: "central",
  pointerEvents: "none"
}, "III"))), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
  className: "house-sector "
}, /*#__PURE__*/React.createElement("path", {
  className: "house-hit",
  d: "M 173.0506483323189 489.38812558118696 A 228 228 0 0 0 280.8959046650704 527.1982252162942 L 300 300 Z"
}), /*#__PURE__*/React.createElement("line", {
  className: "house-ray",
  x1: 300,
  y1: 300,
  x2: 173.0506483323189,
  y2: 489.38812558118696,
  pointerEvents: "none",
  "data-cusp": 136.50839651031998
}), /*#__PURE__*/React.createElement("text", {
  className: "house-number",
  x: 265.59146372893025,
  y: 398.1430213091205,
  textAnchor: "middle",
  dominantBaseline: "central",
  pointerEvents: "none"
}, "IV"))), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
  className: "house-sector "
}, /*#__PURE__*/React.createElement("path", {
  className: "house-hit",
  d: "M 280.8959046650704 527.1982252162942 A 228 228 0 0 0 447.2850545589058 474.043421891148 L 300 300 Z"
}), /*#__PURE__*/React.createElement("line", {
  className: "house-ray",
  x1: 300,
  y1: 300,
  x2: 280.8959046650704,
  y2: 527.1982252162942,
  pointerEvents: "none",
  "data-cusp": 165.53642084388116
}), /*#__PURE__*/React.createElement("text", {
  className: "house-number",
  x: 331.6482122961727,
  y: 399.06760650412616,
  textAnchor: "middle",
  dominantBaseline: "central",
  pointerEvents: "none"
}, "V"))), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
  className: "house-sector "
}, /*#__PURE__*/React.createElement("path", {
  className: "house-hit",
  d: "M 447.2850545589058 474.043421891148 A 228 228 0 0 0 528 300 L 300 300 Z"
}), /*#__PURE__*/React.createElement("line", {
  className: "house-ray",
  x1: 300,
  y1: 300,
  x2: 447.2850545589058,
  y2: 474.043421891148,
  pointerEvents: "none",
  "data-cusp": 210.58258721808994
}), /*#__PURE__*/React.createElement("text", {
  className: "house-number",
  x: 394.34775109245703,
  y: 343.7550210124024,
  textAnchor: "middle",
  dominantBaseline: "central",
  pointerEvents: "none"
}, "VI"))), _g17 || (_g17 = /*#__PURE__*/React.createElement("g", {
  className: "house-sector "
}, /*#__PURE__*/React.createElement("path", {
  className: "house-hit",
  d: "M 528 300 A 228 228 0 0 0 516.4843639612228 228.4561661615425 L 300 300 Z"
}), /*#__PURE__*/React.createElement("line", {
  className: "house-ray",
  x1: 300,
  y1: 300,
  x2: 528,
  y2: 300,
  pointerEvents: "none",
  "data-cusp": 260.3428633745028
}), /*#__PURE__*/React.createElement("text", {
  className: "house-number",
  x: 402.6784163994961,
  y: 283.4729674263134,
  textAnchor: "middle",
  dominantBaseline: "central",
  pointerEvents: "none"
}, "VII"))), _g18 || (_g18 = /*#__PURE__*/React.createElement("g", {
  className: "house-sector "
}, /*#__PURE__*/React.createElement("path", {
  className: "house-hit",
  d: "M 516.4843639612228 228.4561661615425 A 228 228 0 0 0 485.22262666303436 167.04670529826583 L 300 300 Z"
}), /*#__PURE__*/React.createElement("line", {
  className: "house-ray",
  x1: 300,
  y1: 300,
  x2: 516.4843639612228,
  y2: 228.4561661615425,
  pointerEvents: "none",
  "data-cusp": 278.6305702874025
}), /*#__PURE__*/React.createElement("text", {
  className: "house-number",
  x: 392.6817334413428,
  y: 252.8184751591486,
  textAnchor: "middle",
  dominantBaseline: "central",
  pointerEvents: "none"
}, "VIII"))), _g19 || (_g19 = /*#__PURE__*/React.createElement("g", {
  className: "house-sector "
}, /*#__PURE__*/React.createElement("path", {
  className: "house-hit",
  d: "M 485.22262666303436 167.04670529826583 A 228 228 0 0 0 426.94935166768096 110.61187441881293 L 300 300 Z"
}), /*#__PURE__*/React.createElement("line", {
  className: "house-ray",
  x1: 300,
  y1: 300,
  x2: 485.22262666303436,
  y2: 167.04670529826583,
  pointerEvents: "none",
  "data-cusp": 296.0137492113849
}), /*#__PURE__*/React.createElement("text", {
  className: "house-number",
  x: 372.3511910979172,
  y: 225.2918669306168,
  textAnchor: "middle",
  dominantBaseline: "central",
  pointerEvents: "none"
}, "IX"))), _g20 || (_g20 = /*#__PURE__*/React.createElement("g", {
  className: "house-sector "
}, /*#__PURE__*/React.createElement("path", {
  className: "house-hit",
  d: "M 426.94935166768096 110.61187441881293 A 228 228 0 0 0 319.10409533492964 72.80177478370587 L 300 300 Z"
}), /*#__PURE__*/React.createElement("line", {
  className: "house-ray",
  x1: 300,
  y1: 300,
  x2: 426.94935166768096,
  y2: 110.61187441881293,
  pointerEvents: "none",
  "data-cusp": 316.50839651032
}), /*#__PURE__*/React.createElement("text", {
  className: "house-number",
  x: 334.4085362710698,
  y: 201.85697869087954,
  textAnchor: "middle",
  dominantBaseline: "central",
  pointerEvents: "none"
}, "X"))), _g21 || (_g21 = /*#__PURE__*/React.createElement("g", {
  className: "house-sector "
}, /*#__PURE__*/React.createElement("path", {
  className: "house-hit",
  d: "M 319.10409533492964 72.80177478370587 A 228 228 0 0 0 152.71494544109396 125.9565781088522 L 300 300 Z"
}), /*#__PURE__*/React.createElement("line", {
  className: "house-ray",
  x1: 300,
  y1: 300,
  x2: 319.10409533492964,
  y2: 72.80177478370587,
  pointerEvents: "none",
  "data-cusp": 345.53642084388116
}), /*#__PURE__*/React.createElement("text", {
  className: "house-number",
  x: 268.3517877038274,
  y: 200.93239349587378,
  textAnchor: "middle",
  dominantBaseline: "central",
  pointerEvents: "none"
}, "XI"))), _g22 || (_g22 = /*#__PURE__*/React.createElement("g", {
  className: "house-sector "
}, /*#__PURE__*/React.createElement("path", {
  className: "house-hit",
  d: "M 152.71494544109422 125.956578108852 A 228 228 0 0 0 72 300 L 300 300 Z"
}), /*#__PURE__*/React.createElement("line", {
  className: "house-ray",
  x1: 300,
  y1: 300,
  x2: 152.71494544109422,
  y2: 125.956578108852,
  pointerEvents: "none",
  "data-cusp": 30.58258721808994
}), /*#__PURE__*/React.createElement("text", {
  className: "house-number",
  x: 205.65224890754297,
  y: 256.2449789875976,
  textAnchor: "middle",
  dominantBaseline: "central",
  pointerEvents: "none"
}, "XII"))), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
  cx: 300,
  cy: 300,
  r: 88,
  className: "aspect-surface"
})), _g23 || (_g23 = /*#__PURE__*/React.createElement("g", {
  className: "aspect-layer"
}, /*#__PURE__*/React.createElement("g", {
  className: "wheel-aspect conjunction",
  "data-aspect-id": "aspect-0"
}, /*#__PURE__*/React.createElement("path", {
  className: "aspect-stroke",
  d: "M 382.11826750105706 268.3678938003674 Q 368.80412995571305 278.8300327112738 385.6966836104382 279.9980396417638"
}), /*#__PURE__*/React.createElement("circle", {
  className: "conjunction-marker",
  cx: 382.11826750105706,
  cy: 268.3678938003674,
  r: 4
}), /*#__PURE__*/React.createElement("path", {
  className: "aspect-hit",
  d: "M 382.11826750105706 268.3678938003674 Q 368.80412995571305 278.8300327112738 385.6966836104382 279.9980396417638"
}), /*#__PURE__*/React.createElement("circle", {
  className: "conjunction-hit",
  cx: 382.11826750105706,
  cy: 268.3678938003674,
  r: 9
})), /*#__PURE__*/React.createElement("g", {
  className: "wheel-aspect soft",
  "data-aspect-id": "aspect-1"
}, /*#__PURE__*/React.createElement("path", {
  className: "aspect-stroke",
  d: "M 382.11826750105706 268.3678938003674 L 232.55515522614914 243.47396251787004"
}), /*#__PURE__*/React.createElement("path", {
  className: "aspect-hit",
  d: "M 382.11826750105706 268.3678938003674 L 232.55515522614914 243.47396251787004"
})), /*#__PURE__*/React.createElement("g", {
  className: "wheel-aspect conjunction",
  "data-aspect-id": "aspect-3"
}, /*#__PURE__*/React.createElement("path", {
  className: "aspect-stroke",
  d: "M 379.8753466731621 336.9314093129706 Q 367.15099012592003 326.01671362819087 383.9075560729844 326.5239897801779"
}), /*#__PURE__*/React.createElement("circle", {
  className: "conjunction-marker",
  cx: 379.8753466731621,
  cy: 336.9314093129706,
  r: 4
}), /*#__PURE__*/React.createElement("path", {
  className: "aspect-hit",
  d: "M 379.8753466731621 336.9314093129706 Q 367.15099012592003 326.01671362819087 383.9075560729844 326.5239897801779"
}), /*#__PURE__*/React.createElement("circle", {
  className: "conjunction-hit",
  cx: 379.8753466731621,
  cy: 336.9314093129706,
  r: 9
})), /*#__PURE__*/React.createElement("g", {
  className: "wheel-aspect hard",
  "data-aspect-id": "aspect-4"
}, /*#__PURE__*/React.createElement("path", {
  className: "aspect-stroke",
  d: "M 379.8753466731621 336.9314093129706 L 332.3774002674702 218.17271877961468",
  strokeDasharray: "8 3"
}), /*#__PURE__*/React.createElement("path", {
  className: "aspect-hit",
  d: "M 379.8753466731621 336.9314093129706 L 332.3774002674702 218.17271877961468"
})), /*#__PURE__*/React.createElement("g", {
  className: "wheel-aspect soft",
  "data-aspect-id": "aspect-5"
}, /*#__PURE__*/React.createElement("path", {
  className: "aspect-stroke",
  d: "M 379.8753466731621 336.9314093129706 L 364.47784493820154 240.11170805470204",
  strokeDasharray: "3 4"
}), /*#__PURE__*/React.createElement("path", {
  className: "aspect-hit",
  d: "M 379.8753466731621 336.9314093129706 L 364.47784493820154 240.11170805470204"
})), /*#__PURE__*/React.createElement("g", {
  className: "wheel-aspect soft",
  "data-aspect-id": "aspect-6"
}, /*#__PURE__*/React.createElement("path", {
  className: "aspect-stroke",
  d: "M 385.6966836104382 279.9980396417638 L 332.3774002674702 218.17271877961468",
  strokeDasharray: "3 4"
}), /*#__PURE__*/React.createElement("path", {
  className: "aspect-hit",
  d: "M 385.6966836104382 279.9980396417638 L 332.3774002674702 218.17271877961468"
})), /*#__PURE__*/React.createElement("g", {
  className: "wheel-aspect soft",
  "data-aspect-id": "aspect-7"
}, /*#__PURE__*/React.createElement("path", {
  className: "aspect-stroke",
  d: "M 385.6966836104382 279.9980396417638 L 232.55515522614914 243.47396251787004"
}), /*#__PURE__*/React.createElement("path", {
  className: "aspect-hit",
  d: "M 385.6966836104382 279.9980396417638 L 232.55515522614914 243.47396251787004"
})), /*#__PURE__*/React.createElement("g", {
  className: "wheel-aspect hard",
  "data-aspect-id": "aspect-9"
}, /*#__PURE__*/React.createElement("path", {
  className: "aspect-stroke",
  d: "M 383.9075560729844 326.5239897801779 L 332.3774002674702 218.17271877961468",
  strokeDasharray: "8 3"
}), /*#__PURE__*/React.createElement("path", {
  className: "aspect-hit",
  d: "M 383.9075560729844 326.5239897801779 L 332.3774002674702 218.17271877961468"
})), /*#__PURE__*/React.createElement("g", {
  className: "wheel-aspect soft",
  "data-aspect-id": "aspect-10"
}, /*#__PURE__*/React.createElement("path", {
  className: "aspect-stroke",
  d: "M 383.9075560729844 326.5239897801779 L 364.47784493820154 240.11170805470204",
  strokeDasharray: "3 4"
}), /*#__PURE__*/React.createElement("path", {
  className: "aspect-hit",
  d: "M 383.9075560729844 326.5239897801779 L 364.47784493820154 240.11170805470204"
})), /*#__PURE__*/React.createElement("g", {
  className: "wheel-aspect soft",
  "data-aspect-id": "aspect-11"
}, /*#__PURE__*/React.createElement("path", {
  className: "aspect-stroke",
  d: "M 383.9075560729844 326.5239897801779 L 236.22032438349186 360.6312871235058"
}), /*#__PURE__*/React.createElement("path", {
  className: "aspect-hit",
  d: "M 383.9075560729844 326.5239897801779 L 236.22032438349186 360.6312871235058"
})), /*#__PURE__*/React.createElement("g", {
  className: "wheel-aspect soft",
  "data-aspect-id": "aspect-14"
}, /*#__PURE__*/React.createElement("path", {
  className: "aspect-stroke",
  d: "M 332.3774002674702 218.17271877961468 L 249.5837475971067 227.87371149402074",
  strokeDasharray: "3 4"
}), /*#__PURE__*/React.createElement("path", {
  className: "aspect-hit",
  d: "M 332.3774002674702 218.17271877961468 L 249.5837475971067 227.87371149402074"
})), /*#__PURE__*/React.createElement("g", {
  className: "wheel-aspect hard",
  "data-aspect-id": "aspect-17"
}, /*#__PURE__*/React.createElement("path", {
  className: "aspect-stroke",
  d: "M 249.5837475971067 227.87371149402074 L 364.47784493820154 240.11170805470204",
  strokeDasharray: "8 3"
}), /*#__PURE__*/React.createElement("path", {
  className: "aspect-hit",
  d: "M 249.5837475971067 227.87371149402074 L 364.47784493820154 240.11170805470204"
})), /*#__PURE__*/React.createElement("g", {
  className: "wheel-aspect soft",
  "data-aspect-id": "aspect-18"
}, /*#__PURE__*/React.createElement("path", {
  className: "aspect-stroke",
  d: "M 249.5837475971067 227.87371149402074 L 212 300",
  strokeDasharray: "3 4"
}), /*#__PURE__*/React.createElement("path", {
  className: "aspect-hit",
  d: "M 249.5837475971067 227.87371149402074 L 212 300"
})), /*#__PURE__*/React.createElement("g", {
  className: "wheel-aspect soft",
  "data-aspect-id": "aspect-19"
}, /*#__PURE__*/React.createElement("path", {
  className: "aspect-stroke",
  d: "M 249.5837475971067 227.87371149402074 L 388 300"
}), /*#__PURE__*/React.createElement("path", {
  className: "aspect-hit",
  d: "M 249.5837475971067 227.87371149402074 L 388 300"
})), /*#__PURE__*/React.createElement("g", {
  className: "wheel-aspect hard",
  "data-aspect-id": "aspect-22"
}, /*#__PURE__*/React.createElement("path", {
  className: "aspect-stroke",
  d: "M 232.55515522614914 243.47396251787004 L 351.0793726772455 228.34179958372476",
  strokeDasharray: "8 3"
}), /*#__PURE__*/React.createElement("path", {
  className: "aspect-hit",
  d: "M 232.55515522614914 243.47396251787004 L 351.0793726772455 228.34179958372476"
})), /*#__PURE__*/React.createElement("g", {
  className: "wheel-aspect hard",
  "data-aspect-id": "aspect-23"
}, /*#__PURE__*/React.createElement("path", {
  className: "aspect-stroke",
  d: "M 232.55515522614914 243.47396251787004 L 364.47784493820154 240.11170805470204",
  strokeDasharray: "8 3"
}), /*#__PURE__*/React.createElement("path", {
  className: "aspect-hit",
  d: "M 232.55515522614914 243.47396251787004 L 364.47784493820154 240.11170805470204"
})), /*#__PURE__*/React.createElement("g", {
  className: "wheel-aspect hard",
  "data-aspect-id": "aspect-24"
}, /*#__PURE__*/React.createElement("path", {
  className: "aspect-stroke",
  d: "M 232.55515522614914 243.47396251787004 L 236.22032438349186 360.6312871235058",
  strokeDasharray: "8 3"
}), /*#__PURE__*/React.createElement("path", {
  className: "aspect-hit",
  d: "M 232.55515522614914 243.47396251787004 L 236.22032438349186 360.6312871235058"
})), /*#__PURE__*/React.createElement("g", {
  className: "wheel-aspect hard",
  "data-aspect-id": "aspect-26"
}, /*#__PURE__*/React.createElement("path", {
  className: "aspect-stroke",
  d: "M 232.55515522614914 243.47396251787004 L 348.9979953805084 226.90282872305062",
  strokeDasharray: "8 3"
}), /*#__PURE__*/React.createElement("path", {
  className: "aspect-hit",
  d: "M 232.55515522614914 243.47396251787004 L 348.9979953805084 226.90282872305062"
})), /*#__PURE__*/React.createElement("g", {
  className: "wheel-aspect hard",
  "data-aspect-id": "aspect-27"
}, /*#__PURE__*/React.createElement("path", {
  className: "aspect-stroke",
  d: "M 232.55515522614914 243.47396251787004 L 251.00200461949152 373.0971712769493",
  strokeDasharray: "8 3"
}), /*#__PURE__*/React.createElement("path", {
  className: "aspect-hit",
  d: "M 232.55515522614914 243.47396251787004 L 251.00200461949152 373.0971712769493"
})), /*#__PURE__*/React.createElement("g", {
  className: "wheel-aspect soft",
  "data-aspect-id": "aspect-30"
}, /*#__PURE__*/React.createElement("path", {
  className: "aspect-stroke",
  d: "M 351.0793726772455 228.34179958372476 L 386.951748986908 313.54228001917505",
  strokeDasharray: "3 4"
}), /*#__PURE__*/React.createElement("path", {
  className: "aspect-hit",
  d: "M 351.0793726772455 228.34179958372476 L 386.951748986908 313.54228001917505"
})), /*#__PURE__*/React.createElement("g", {
  className: "wheel-aspect soft",
  "data-aspect-id": "aspect-31"
}, /*#__PURE__*/React.createElement("path", {
  className: "aspect-stroke",
  d: "M 351.0793726772455 228.34179958372476 L 212 300"
}), /*#__PURE__*/React.createElement("path", {
  className: "aspect-hit",
  d: "M 351.0793726772455 228.34179958372476 L 212 300"
})), /*#__PURE__*/React.createElement("g", {
  className: "wheel-aspect soft",
  "data-aspect-id": "aspect-32"
}, /*#__PURE__*/React.createElement("path", {
  className: "aspect-stroke",
  d: "M 351.0793726772455 228.34179958372476 L 388 300",
  strokeDasharray: "3 4"
}), /*#__PURE__*/React.createElement("path", {
  className: "aspect-hit",
  d: "M 351.0793726772455 228.34179958372476 L 388 300"
})), /*#__PURE__*/React.createElement("g", {
  className: "wheel-aspect conjunction",
  "data-aspect-id": "aspect-33"
}, /*#__PURE__*/React.createElement("path", {
  className: "aspect-stroke",
  d: "M 351.0793726772455 228.34179958372476 Q 341.0317209036791 240.6502976057779 348.9979953805084 226.90282872305062"
}), /*#__PURE__*/React.createElement("circle", {
  className: "conjunction-marker",
  cx: 351.0793726772455,
  cy: 228.34179958372476,
  r: 4
}), /*#__PURE__*/React.createElement("path", {
  className: "aspect-hit",
  d: "M 351.0793726772455 228.34179958372476 Q 341.0317209036791 240.6502976057779 348.9979953805084 226.90282872305062"
}), /*#__PURE__*/React.createElement("circle", {
  className: "conjunction-hit",
  cx: 351.0793726772455,
  cy: 228.34179958372476,
  r: 9
})), /*#__PURE__*/React.createElement("g", {
  className: "wheel-aspect hard",
  "data-aspect-id": "aspect-34"
}, /*#__PURE__*/React.createElement("path", {
  className: "aspect-stroke",
  d: "M 351.0793726772455 228.34179958372476 L 251.00200461949152 373.0971712769493"
}), /*#__PURE__*/React.createElement("path", {
  className: "aspect-hit",
  d: "M 351.0793726772455 228.34179958372476 L 251.00200461949152 373.0971712769493"
})), /*#__PURE__*/React.createElement("g", {
  className: "wheel-aspect hard",
  "data-aspect-id": "aspect-36"
}, /*#__PURE__*/React.createElement("path", {
  className: "aspect-stroke",
  d: "M 364.47784493820154 240.11170805470204 L 236.22032438349186 360.6312871235058"
}), /*#__PURE__*/React.createElement("path", {
  className: "aspect-hit",
  d: "M 364.47784493820154 240.11170805470204 L 236.22032438349186 360.6312871235058"
})), /*#__PURE__*/React.createElement("g", {
  className: "wheel-aspect soft",
  "data-aspect-id": "aspect-40"
}, /*#__PURE__*/React.createElement("path", {
  className: "aspect-stroke",
  d: "M 386.951748986908 313.54228001917505 L 236.22032438349186 360.6312871235058"
}), /*#__PURE__*/React.createElement("path", {
  className: "aspect-hit",
  d: "M 386.951748986908 313.54228001917505 L 236.22032438349186 360.6312871235058"
})), /*#__PURE__*/React.createElement("g", {
  className: "wheel-aspect soft",
  "data-aspect-id": "aspect-42"
}, /*#__PURE__*/React.createElement("path", {
  className: "aspect-stroke",
  d: "M 386.951748986908 313.54228001917505 L 348.9979953805084 226.90282872305062",
  strokeDasharray: "3 4"
}), /*#__PURE__*/React.createElement("path", {
  className: "aspect-hit",
  d: "M 386.951748986908 313.54228001917505 L 348.9979953805084 226.90282872305062"
})), /*#__PURE__*/React.createElement("g", {
  className: "wheel-aspect soft",
  "data-aspect-id": "aspect-43"
}, /*#__PURE__*/React.createElement("path", {
  className: "aspect-stroke",
  d: "M 386.951748986908 313.54228001917505 L 251.00200461949152 373.0971712769493"
}), /*#__PURE__*/React.createElement("path", {
  className: "aspect-hit",
  d: "M 386.951748986908 313.54228001917505 L 251.00200461949152 373.0971712769493"
})), /*#__PURE__*/React.createElement("g", {
  className: "wheel-aspect hard",
  "data-aspect-id": "aspect-50"
}, /*#__PURE__*/React.createElement("path", {
  className: "aspect-stroke",
  d: "M 212 300 L 388 300"
}), /*#__PURE__*/React.createElement("path", {
  className: "aspect-hit",
  d: "M 212 300 L 388 300"
})), /*#__PURE__*/React.createElement("g", {
  className: "wheel-aspect soft",
  "data-aspect-id": "aspect-51"
}, /*#__PURE__*/React.createElement("path", {
  className: "aspect-stroke",
  d: "M 212 300 L 348.9979953805084 226.90282872305062"
}), /*#__PURE__*/React.createElement("path", {
  className: "aspect-hit",
  d: "M 212 300 L 348.9979953805084 226.90282872305062"
})), /*#__PURE__*/React.createElement("g", {
  className: "wheel-aspect soft",
  "data-aspect-id": "aspect-52"
}, /*#__PURE__*/React.createElement("path", {
  className: "aspect-stroke",
  d: "M 212 300 L 251.00200461949152 373.0971712769493",
  strokeDasharray: "3 4"
}), /*#__PURE__*/React.createElement("path", {
  className: "aspect-hit",
  d: "M 212 300 L 251.00200461949152 373.0971712769493"
})), /*#__PURE__*/React.createElement("g", {
  className: "wheel-aspect soft",
  "data-aspect-id": "aspect-55"
}, /*#__PURE__*/React.createElement("path", {
  className: "aspect-stroke",
  d: "M 388 300 L 348.9979953805084 226.90282872305062",
  strokeDasharray: "3 4"
}), /*#__PURE__*/React.createElement("path", {
  className: "aspect-hit",
  d: "M 388 300 L 348.9979953805084 226.90282872305062"
})), /*#__PURE__*/React.createElement("g", {
  className: "wheel-aspect soft",
  "data-aspect-id": "aspect-56"
}, /*#__PURE__*/React.createElement("path", {
  className: "aspect-stroke",
  d: "M 388 300 L 251.00200461949152 373.0971712769493"
}), /*#__PURE__*/React.createElement("path", {
  className: "aspect-hit",
  d: "M 388 300 L 251.00200461949152 373.0971712769493"
})), /*#__PURE__*/React.createElement("g", {
  className: "wheel-aspect hard",
  "data-aspect-id": "aspect-59"
}, /*#__PURE__*/React.createElement("path", {
  className: "aspect-stroke",
  d: "M 348.9979953805084 226.90282872305062 L 251.00200461949152 373.0971712769493"
}), /*#__PURE__*/React.createElement("path", {
  className: "aspect-hit",
  d: "M 348.9979953805084 226.90282872305062 L 251.00200461949152 373.0971712769493"
})))), _g24 || (_g24 = /*#__PURE__*/React.createElement("g", {
  className: "angle-marker"
}, /*#__PURE__*/React.createElement("line", {
  x1: 182,
  y1: 300,
  x2: 28,
  y2: 300.00000000000006
}), /*#__PURE__*/React.createElement("rect", {
  className: "angle-label-bg",
  x: 5,
  y: 290.00000000000006,
  width: 30,
  height: 20,
  rx: 3
}), /*#__PURE__*/React.createElement("text", {
  x: 20,
  y: 300.00000000000006,
  textAnchor: "middle",
  dominantBaseline: "central"
}, "ASC"))), _g25 || (_g25 = /*#__PURE__*/React.createElement("g", {
  className: "angle-marker"
}, /*#__PURE__*/React.createElement("line", {
  x1: 418,
  y1: 300,
  x2: 572,
  y2: 300
}), /*#__PURE__*/React.createElement("rect", {
  className: "angle-label-bg",
  x: 565,
  y: 290,
  width: 30,
  height: 20,
  rx: 3
}), /*#__PURE__*/React.createElement("text", {
  x: 580,
  y: 300,
  textAnchor: "middle",
  dominantBaseline: "central"
}, "DSC"))), _g26 || (_g26 = /*#__PURE__*/React.createElement("g", {
  className: "angle-marker"
}, /*#__PURE__*/React.createElement("line", {
  x1: 365.70185744204537,
  y1: 201.98333851499967,
  x2: 451.4483493579352,
  y2: 74.06328878033824
}), /*#__PURE__*/React.createElement("rect", {
  className: "angle-label-bg",
  x: 440.902712574345,
  y: 57.418091391524655,
  width: 30,
  height: 20,
  rx: 3
}), /*#__PURE__*/React.createElement("text", {
  x: 455.902712574345,
  y: 67.41809139152465,
  textAnchor: "middle",
  dominantBaseline: "central"
}, "MC"))), _g27 || (_g27 = /*#__PURE__*/React.createElement("g", {
  className: "angle-marker"
}, /*#__PURE__*/React.createElement("line", {
  x1: 234.29814255795452,
  y1: 398.01666148500027,
  x2: 148.55165064206466,
  y2: 525.9367112196616
}), /*#__PURE__*/React.createElement("rect", {
  className: "angle-label-bg",
  x: 129.0972874256548,
  y: 522.5819086084751,
  width: 30,
  height: 20,
  rx: 3
}), /*#__PURE__*/React.createElement("text", {
  x: 144.0972874256548,
  y: 532.5819086084751,
  textAnchor: "middle",
  dominantBaseline: "central"
}, "IC"))), _g28 || (_g28 = /*#__PURE__*/React.createElement("g", {
  className: "point-anchor",
  "data-point-anchor": "\\u2609"
}, /*#__PURE__*/React.createElement("path", {
  d: "M 512.7609657981934 218.04408848277018 L 507.1619930140304 220.20082299638148 L 442.4659918209336 207.2452633313119",
  className: "anchor-leader"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 512.7609657981934,
  cy: 218.04408848277018,
  r: 2.5
}))), _g29 || (_g29 = /*#__PURE__*/React.createElement("g", {
  className: "point-anchor",
  "data-point-anchor": "\\u263D"
}, /*#__PURE__*/React.createElement("path", {
  d: "M 506.9497618350109 395.6859241290602 L 501.50371547093164 393.1678734940849 L 490.6116227427734 388.131772224134",
  className: "anchor-leader"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 506.9497618350109,
  cy: 395.6859241290602,
  r: 2.5
}))), _g30 || (_g30 = /*#__PURE__*/React.createElement("g", {
  className: "point-anchor",
  "data-point-anchor": "\\u263F"
}, /*#__PURE__*/React.createElement("path", {
  d: "M 522.0323166270445 248.17673907184258 L 516.1893609263327 249.54050909626778 L 493.345994750327 218.04070330946882",
  className: "anchor-leader"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 522.0323166270445,
  cy: 248.17673907184258,
  r: 2.5
}))), _g31 || (_g31 = /*#__PURE__*/React.createElement("g", {
  className: "point-anchor",
  "data-point-anchor": "\\u2640"
}, /*#__PURE__*/React.createElement("path", {
  d: "M 517.3968498254595 368.7212462486426 L 511.6758800932106 366.91279239999415 L 508.1025174342752 328.16633163046197",
  className: "anchor-leader"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 517.3968498254595,
  cy: 368.7212462486426,
  r: 2.5
}))), _g32 || (_g32 = /*#__PURE__*/React.createElement("g", {
  className: "point-anchor",
  "data-point-anchor": "\\u2642"
}, /*#__PURE__*/React.createElement("path", {
  d: "M 383.8869006929909 87.99295320172897 L 381.6793506747543 93.57208601220978 L 324.9973123748435 91.49308315061944",
  className: "anchor-leader"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 383.8869006929909,
  cy: 87.99295320172897,
  r: 2.5
}))), _g33 || (_g33 = /*#__PURE__*/React.createElement("g", {
  className: "point-anchor",
  "data-point-anchor": "\\u2643"
}, /*#__PURE__*/React.createElement("path", {
  d: "M 169.37607331977648 113.12734341632645 L 172.8135450745192 118.0450449053705 L 179.68848858400466 127.88044788345857",
  className: "anchor-leader"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 169.37607331977648,
  cy: 113.12734341632645,
  r: 2.5
}))), _g34 || (_g34 = /*#__PURE__*/React.createElement("g", {
  className: "point-anchor",
  "data-point-anchor": "\\u2644"
}, /*#__PURE__*/React.createElement("path", {
  d: "M 125.25653854047732 153.54617561448143 L 129.85505068414898 157.40022362462668 L 128.0822581702899 179.40029003279838",
  className: "anchor-leader"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 125.25653854047732,
  cy: 153.54617561448143,
  r: 2.5
}))), _g35 || (_g35 = /*#__PURE__*/React.createElement("g", {
  className: "point-anchor",
  "data-point-anchor": "\\u2645"
}, /*#__PURE__*/React.createElement("path", {
  d: "M 432.3420110274087 114.3401171032869 L 428.8593265266875 119.22590349530566 L 390.8960295293961 110.69096213917535",
  className: "anchor-leader"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 432.3420110274087,
  cy: 114.3401171032869,
  r: 2.5
}))), _g36 || (_g36 = /*#__PURE__*/React.createElement("g", {
  className: "point-anchor",
  "data-point-anchor": "\\u2646"
}, /*#__PURE__*/React.createElement("path", {
  d: "M 467.056234612613 144.83487995990984 L 462.6600179122811 148.9181725925438 L 441.0514367473195 144.42207035855975",
  className: "anchor-leader"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 467.056234612613,
  cy: 144.83487995990984,
  r: 2.5
}))), _g37 || (_g37 = /*#__PURE__*/React.createElement("g", {
  className: "point-anchor",
  "data-point-anchor": "\\u2647"
}, /*#__PURE__*/React.createElement("path", {
  d: "M 525.2840769206252 335.08681641331714 L 519.3555485806087 334.16347913928246 L 467.8379518725078 272.9736811377918",
  className: "anchor-leader"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 525.2840769206252,
  cy: 335.08681641331714,
  r: 2.5
}))), _g38 || (_g38 = /*#__PURE__*/React.createElement("g", {
  className: "point-anchor",
  "data-point-anchor": "\\u260A"
}, /*#__PURE__*/React.createElement("path", {
  d: "M 134.7526586299562 457.09015300181045 L 139.10127287653629 452.95620160702595 L 147.79850136969648 444.68829881745694",
  className: "anchor-leader"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 134.7526586299562,
  cy: 457.09015300181045,
  r: 2.5
}))), _g39 || (_g39 = /*#__PURE__*/React.createElement("g", {
  className: "planet-label",
  "data-label": "\\u2643"
}, /*#__PURE__*/React.createElement("circle", {
  className: "planet-hit",
  cx: 179.68848858400466,
  cy: 127.88044788345857,
  r: 22
}), /*#__PURE__*/React.createElement("circle", {
  className: "planet-disc",
  cx: 179.68848858400466,
  cy: 127.88044788345857,
  r: 16.5
}), /*#__PURE__*/React.createElement("use", {
  href: "#R0-g5",
  x: 167.68848858400466,
  y: 115.88044788345857,
  width: 24,
  height: 24,
  "aria-hidden": "true"
}), /*#__PURE__*/React.createElement("text", {
  className: "planet-degree-v2",
  x: 179.68848858400466,
  y: 104.88044788345857,
  textAnchor: "middle"
}, "25\xB017\u2032"))), _g40 || (_g40 = /*#__PURE__*/React.createElement("g", {
  className: "planet-label",
  "data-label": "\\u2644"
}, /*#__PURE__*/React.createElement("circle", {
  className: "planet-hit",
  cx: 128.0822581702899,
  cy: 179.40029003279838,
  r: 22
}), /*#__PURE__*/React.createElement("circle", {
  className: "planet-disc",
  cx: 128.0822581702899,
  cy: 179.40029003279838,
  r: 16.5
}), /*#__PURE__*/React.createElement("use", {
  href: "#R0-g6",
  x: 116.08225817028989,
  y: 167.40029003279838,
  width: 24,
  height: 24,
  "aria-hidden": "true"
}), /*#__PURE__*/React.createElement("text", {
  className: "retrograde-mark",
  x: 141.0822581702899,
  y: 195.40029003279838
}, "R"), /*#__PURE__*/React.createElement("text", {
  className: "planet-degree-v2",
  x: 128.0822581702899,
  y: 156.40029003279838,
  textAnchor: "middle"
}, "10\xB022\u2032"))), _g41 || (_g41 = /*#__PURE__*/React.createElement("g", {
  className: "planet-label",
  "data-label": "\\u260A"
}, /*#__PURE__*/React.createElement("circle", {
  className: "planet-hit",
  cx: 147.79850136969648,
  cy: 444.68829881745694,
  r: 22
}), /*#__PURE__*/React.createElement("circle", {
  className: "planet-disc",
  cx: 147.79850136969648,
  cy: 444.68829881745694,
  r: 16.5
}), /*#__PURE__*/React.createElement("use", {
  href: "#R0-g10",
  x: 135.79850136969648,
  y: 432.68829881745694,
  width: 24,
  height: 24,
  "aria-hidden": "true"
}), /*#__PURE__*/React.createElement("text", {
  className: "retrograde-mark",
  x: 160.79850136969648,
  y: 460.68829881745694
}, "R"), /*#__PURE__*/React.createElement("text", {
  className: "planet-degree-v2",
  x: 147.79850136969648,
  y: 421.68829881745694,
  textAnchor: "middle"
}, "3\xB053\u2032"))), _g42 || (_g42 = /*#__PURE__*/React.createElement("g", {
  className: "planet-label",
  "data-label": "\\u263D"
}, /*#__PURE__*/React.createElement("circle", {
  className: "planet-hit",
  cx: 490.6116227427734,
  cy: 388.131772224134,
  r: 22
}), /*#__PURE__*/React.createElement("circle", {
  className: "planet-disc",
  cx: 490.6116227427734,
  cy: 388.131772224134,
  r: 16.5
}), /*#__PURE__*/React.createElement("use", {
  href: "#R0-g1",
  x: 478.6116227427734,
  y: 376.131772224134,
  width: 24,
  height: 24,
  "aria-hidden": "true"
}), /*#__PURE__*/React.createElement("text", {
  className: "planet-degree-v2",
  x: 490.6116227427734,
  y: 365.131772224134,
  textAnchor: "middle"
}, "25\xB031\u2032"))), _g43 || (_g43 = /*#__PURE__*/React.createElement("g", {
  className: "planet-label",
  "data-label": "\\u2640"
}, /*#__PURE__*/React.createElement("circle", {
  className: "planet-hit",
  cx: 508.1025174342752,
  cy: 328.16633163046197,
  r: 22
}), /*#__PURE__*/React.createElement("circle", {
  className: "planet-disc",
  cx: 508.1025174342752,
  cy: 328.16633163046197,
  r: 16.5
}), /*#__PURE__*/React.createElement("use", {
  href: "#R0-g3",
  x: 496.1025174342752,
  y: 316.16633163046197,
  width: 24,
  height: 24,
  "aria-hidden": "true"
}), /*#__PURE__*/React.createElement("text", {
  className: "planet-degree-v2",
  x: 508.1025174342752,
  y: 305.16633163046197,
  textAnchor: "middle"
}, "2\xB048\u2032"))), _g44 || (_g44 = /*#__PURE__*/React.createElement("g", {
  className: "planet-label",
  "data-label": "\\u2647"
}, /*#__PURE__*/React.createElement("circle", {
  className: "planet-hit",
  cx: 467.8379518725078,
  cy: 272.9736811377918,
  r: 22
}), /*#__PURE__*/React.createElement("circle", {
  className: "planet-disc",
  cx: 467.8379518725078,
  cy: 272.9736811377918,
  r: 16.5
}), /*#__PURE__*/React.createElement("use", {
  href: "#R0-g9",
  x: 455.8379518725078,
  y: 260.9736811377918,
  width: 24,
  height: 24,
  "aria-hidden": "true"
}), /*#__PURE__*/React.createElement("text", {
  className: "planet-degree-v2",
  x: 467.8379518725078,
  y: 249.9736811377918,
  textAnchor: "middle"
}, "11\xB029\u2032"))), _g45 || (_g45 = /*#__PURE__*/React.createElement("g", {
  className: "planet-label",
  "data-label": "\\u263F"
}, /*#__PURE__*/React.createElement("circle", {
  className: "planet-hit",
  cx: 493.345994750327,
  cy: 218.04070330946882,
  r: 22
}), /*#__PURE__*/React.createElement("circle", {
  className: "planet-disc",
  cx: 493.345994750327,
  cy: 218.04070330946882,
  r: 16.5
}), /*#__PURE__*/React.createElement("use", {
  href: "#R0-g2",
  x: 481.345994750327,
  y: 206.04070330946882,
  width: 24,
  height: 24,
  "aria-hidden": "true"
}), /*#__PURE__*/React.createElement("text", {
  className: "planet-degree-v2",
  x: 493.345994750327,
  y: 195.04070330946882,
  textAnchor: "middle"
}, "3\xB028\u2032"))), _g46 || (_g46 = /*#__PURE__*/React.createElement("g", {
  className: "planet-label",
  "data-label": "\\u2609"
}, /*#__PURE__*/React.createElement("circle", {
  className: "planet-hit",
  cx: 442.4659918209336,
  cy: 207.2452633313119,
  r: 22
}), /*#__PURE__*/React.createElement("circle", {
  className: "planet-disc",
  cx: 442.4659918209336,
  cy: 207.2452633313119,
  r: 16.5
}), /*#__PURE__*/React.createElement("use", {
  href: "#R0-g0",
  x: 430.4659918209336,
  y: 195.2452633313119,
  width: 24,
  height: 24,
  "aria-hidden": "true"
}), /*#__PURE__*/React.createElement("text", {
  className: "planet-degree-v2",
  x: 442.4659918209336,
  y: 184.2452633313119,
  textAnchor: "middle"
}, "11\xB024\u2032"))), _g47 || (_g47 = /*#__PURE__*/React.createElement("g", {
  className: "planet-label",
  "data-label": "\\u2646"
}, /*#__PURE__*/React.createElement("circle", {
  className: "planet-hit",
  cx: 441.0514367473195,
  cy: 144.42207035855975,
  r: 22
}), /*#__PURE__*/React.createElement("circle", {
  className: "planet-disc",
  cx: 441.0514367473195,
  cy: 144.42207035855975,
  r: 16.5
}), /*#__PURE__*/React.createElement("use", {
  href: "#R0-g8",
  x: 429.0514367473195,
  y: 132.42207035855975,
  width: 24,
  height: 24,
  "aria-hidden": "true"
}), /*#__PURE__*/React.createElement("text", {
  className: "planet-degree-v2",
  x: 441.0514367473195,
  y: 121.42207035855975,
  textAnchor: "middle"
}, "3\xB013\u2032"))), _g48 || (_g48 = /*#__PURE__*/React.createElement("g", {
  className: "planet-label",
  "data-label": "\\u2645"
}, /*#__PURE__*/React.createElement("circle", {
  className: "planet-hit",
  cx: 390.8960295293961,
  cy: 110.69096213917535,
  r: 22
}), /*#__PURE__*/React.createElement("circle", {
  className: "planet-disc",
  cx: 390.8960295293961,
  cy: 110.69096213917535,
  r: 16.5
}), /*#__PURE__*/React.createElement("use", {
  href: "#R0-g7",
  x: 378.8960295293961,
  y: 98.69096213917535,
  width: 24,
  height: 24,
  "aria-hidden": "true"
}), /*#__PURE__*/React.createElement("text", {
  className: "planet-degree-v2",
  x: 390.8960295293961,
  y: 87.69096213917535,
  textAnchor: "middle"
}, "14\xB051\u2032"))), _g49 || (_g49 = /*#__PURE__*/React.createElement("g", {
  className: "planet-label",
  "data-label": "\\u2642"
}, /*#__PURE__*/React.createElement("circle", {
  className: "planet-hit",
  cx: 324.9973123748435,
  cy: 91.49308315061944,
  r: 22
}), /*#__PURE__*/React.createElement("circle", {
  className: "planet-disc",
  cx: 324.9973123748435,
  cy: 91.49308315061944,
  r: 16.5
}), /*#__PURE__*/React.createElement("use", {
  href: "#R0-g4",
  x: 312.9973123748435,
  y: 79.49308315061944,
  width: 24,
  height: 24,
  "aria-hidden": "true"
}), /*#__PURE__*/React.createElement("text", {
  className: "planet-degree-v2",
  x: 324.9973123748435,
  y: 68.49308315061944,
  textAnchor: "middle"
}, "28\xB045\u2032"))));
const ForwardRef = /*#__PURE__*/forwardRef(SvgLandingChartPreview);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/landing-chart-preview.3f081710e1ff6d29a7998bded412d6a8.svg";